 <template>
    <div class="m-2" :style="`direction:`+lang.dir">
        <b-sidebar backdrop id="popViewCard" width="95%" aria-labelledby="sidebar-no-header-title" no-header style="direction:ltr" right :title="lang.view_card" shadow >
            <template #default="{ hide }">
                <div class="m-1 text-start" style="direction:rtl">
                    <div style="width:150px;margin-right:10px;background:#000;color:#FFF;border-radius:5px" class=" btn-sm text-center">
                        <span>{{lang.view_card}}</span>
                    </div>
                    <div @click="hide" id="closecardview" style="text-align:center;float:left;margin-left:5px;margin-top:-25px;cursor:pointer;width:100px;" class="btn-danger btn-sm">
                        <span>{{lang.close}}</span>
                    </div>
                </div>
                <v-divider></v-divider>
                <div :style="`direction:`+lang.dir" class="m-2">
                    <v-col cols="12" v-if="showButtons">
                        <div class="backBlack" style="padding:0px;width:100%;text-align:center;">
                            <b-button style="font-size:1.1rem;border:2px solid #fff !important;background:blue !important;width:120px;color:#fff;" class="mytab2 btn btn-sm btn-success m-2" @click="showAttached()" v-b-toggle.add_gallery>{{lang.attachement}}</b-button>
                            <b-button v-if="card._status_ != 7 && total_payment > 0 && card.status != 2 && card.status != 4" style="font-size:1.1rem;border:2px solid #fff !important;background:red !important;width:150px;color:#fff;" class="mytab2 btn btn-sm btn-success m-2" @click="invpayment()" v-b-toggle.add_addpayment>{{lang.make_payment}}</b-button>
                            <b-button v-if="card._status_ != 7 && card.invoiceid == 0 && $store.state.licenseType.showInvoiceList" class="mytab1 btn btn-sm btn-default m-2" style="border:2px solid #fff !important;width:130px;background:darkgreen !important;font-size:1.1rem;color:#fff;" @click="addInvoice()" v-b-toggle.add_invoice>{{lang.create_invoice}}</b-button>
                            <b-button  class="mytab1 btn btn-sm btn-default m-2" style="width:130px;background:darkslateblue !important;color:#fff !important;font-size:1.1rem;border:2px solid #fff !important" @click="printPDF(cardid,3)">{{lang.print_card}} </b-button>
                            <b-button class="mytab1 btn btn-sm btn-default m-2" style="width:160px;background:#0f766e !important;color:#fff !important;font-size:1.1rem;border:2px solid #fff !important" :disabled="generatingCustomerLink" @click="generateCustomerLink()">{{ lang.generate_customer_link || 'Generate Customer Link' }}</b-button>
                            <b-button v-if="card._status_ != 7 && card.invoiceid != 0" class="mytab1 btn btn-sm btn-default m-2" style="border:2px solid #fff !important;width:130px;background:darkgreen !important;font-size:1.1rem;color:#fff;" @click="printPDF(card.invoiceid,1)">{{lang.view_pdf}}</b-button>
                            <b-button v-if="card._status_ != 7 && card.sined != ''" class="mytab1 btn btn-sm btn-default m-2" style="border:2px solid #fff !important;width:130px;background:darkmagenta !important;font-size:1.1rem;color:#fff;" @click="openSign()">{{lang.customer_sign}}</b-button>
                            <b-button class="mytab1 btn btn-sm btn-default m-2" style="border:2px solid #fff !important;width:130px;background:red !important;font-size:1.1rem;color:#fff;" @click="_chStatus(5)" v-if="card._status_ == 3">{{lang.close_card}}</b-button>
                            <b-button class="mytab1 btn btn-sm btn-default m-2" style="border:2px solid #fff !important;width:130px;background:red !important;font-size:1.1rem;color:#fff;" @click="_chStatus(3)" v-if="card._status_ < 3">{{lang.ready_to_deliver}}</b-button>
                            <b-button class="mytab1 btn btn-sm btn-default m-2" style="border:2px solid #fff !important;width:130px;background:rgb(0, 140, 255) !important;font-size:1.1rem;color:#fff;" @click="_chStatus(7)" v-if="card._status_ <= 3">{{lang.cancel_card}}</b-button>
                            <b-button class="mytab1 btn btn-sm btn-default m-2" style="border:2px solid #fff !important;width:130px;background:rgb(0, 140, 255) !important;font-size:1.1rem;color:#fff;" @click="printWar(card.id)" v-if="$store.state.licenseType.showWarranty">ضمان</b-button>
                            <b-button class="mytab1 btn btn-sm btn-default m-2" style="border:2px solid #fff !important;width:130px;background:red !important;font-size:1.1rem;color:#fff;" @click="delThis(card.id)" v-if="$store.state.licenseType.canDeleteCard && card._status_ != 7 && card.invoiceid == 0 ">حذف</b-button>
                            <b-button class="mytab1 btn btn-sm btn-default m-2" style="border:2px solid #fff !important;width:130px;background:rgb(0, 140, 255) !important;font-size:1.1rem;color:#fff;" @click="goUpdate(card.id)" v-b-toggle.update_cardInfo v-if="$store.state.licenseType.updateCardDet">{{lang.update}}</b-button>
                            <!-- <b-button v-if="card._status_ != 3 && card.paid != card.ftotal" class="mytab1 btn btn-sm btn-default m-2" style="border:none !important;width:120px;background:#FFF !important;font-size:1.1rem;color:#000;" @click="printInvo(d)">{{lang.close_card}}</b-button>  -->
                            <img :src="`../whatsappicon.png`" style="border:2px solid #fff !important;width:120px;margin-inline-start: 10px;height: 38px;border-radius: 5px;cursor:pointer" v-if="$store.state.licenseType.innerWhats" @click="openWhatsAPP()" v-b-toggle.send_card_whats />
                            <img :src="`../whatsappicon.png`" style="border:2px solid #fff !important;width:120px;margin-inline-start: 10px;height: 38px;border-radius: 5px;cursor:pointer" v-else @click="openLWhatsAPP()" />
                        </div>
                        <b-input-group v-if="customerCaseLink" class="mt-2">
                            <b-form-input :value="customerCaseLink" readonly style="direction:ltr;text-align:left" />
                            <b-input-group-append>
                                <b-button variant="outline-primary" @click="copyCustomerLink()">{{ lang.copy || 'Copy' }}</b-button>
                                <b-button variant="outline-success" @click="openCustomerLink()">{{ lang.open || 'Open' }}</b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </v-col>
                </div>

                <div class="pop-tab-wrap">
                    <button
                        type="button"
                        class="btn btn-sm pop-tab-btn"
                        :class="activePopCardTab === 'finance' ? 'btn-primary' : 'btn-outline-primary'"
                        @click="setActivePopCardTab('finance')"
                    >
                        {{ lang.finance_report }} / {{ lang.payments }} / {{ lang.ment_description }}
                    </button>
                    <button
                        type="button"
                        class="btn btn-sm pop-tab-btn"
                        :class="activePopCardTab === 'customer_car_terms' ? 'btn-primary' : 'btn-outline-primary'"
                        @click="setActivePopCardTab('customer_car_terms')"
                    >
                        {{ lang.customer_name }} / {{ card.maintenance_type === 'general' ? lang.device_info : lang.car_info }} / {{ lang.terms_and_conditions }}
                    </button>
                    <button
                        type="button"
                        class="btn btn-sm pop-tab-btn"
                        :class="activePopCardTab === 'expenses_actions' ? 'btn-primary' : 'btn-outline-primary'"
                        @click="setActivePopCardTab('expenses_actions')"
                    >
                        {{ lang.add_new_work_expenses }} / {{ lang.action }}
                    </button>
                    <button
                        type="button"
                        class="btn btn-sm pop-tab-btn"
                        :class="activePopCardTab === 'rest' ? 'btn-primary' : 'btn-outline-primary'"
                        @click="setActivePopCardTab('rest')"
                    >
                        {{ lang.details || 'Rest' }}
                    </button>
                    <button
                        type="button"
                        class="btn btn-sm pop-tab-btn"
                        :class="activePopCardTab === 'spare_parts' ? 'btn-primary' : 'btn-outline-primary'"
                        @click="setActivePopCardTab('spare_parts')"
                    >
                        {{ lang.request_spare_parts_items || lang.request_spare_parts || 'Request Spare Parts Items' }}
                    </button>
                </div>
                <v-row :style="`direction:`+lang.dir" class="m-2">
                    <v-col cols="12" md="12" sm="12" v-if="total_profit < 0 && activePopCardTab === 'rest'">
                        <div style="background: red; color:#fff;padding:5px; border: 1px solid red; text-align:center;">الكرت خاسر بمبلغ اجمالي: {{ total_profit }}</div>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" v-show="activePopCardTab === 'customer_car_terms'">
                        <v-simple-table>
                            <thead>
                                <tr>
                                    <th class="text-center backBlack" style="width:20%;border:1px solid #000 !important;">{{ lang.superVisor }}</th>
                                    <td class="text-center" style="border:1px solid #000 !important;">{{ card.superVisor }}</td>
                                    <th class="text-center backBlack" style="width:20%;border:1px solid #000 !important;">{{ lang.card_type }}</th>
                                    <td class="text-center backBlue" style="border:1px solid #000 !important;">{{ card.card_type }}</td>
                                </tr>
                                <tr>
                                    <th class="text-center backBlack" style="width:20%;border:1px solid #000 !important;">{{ lang.cardid }}</th>
                                    <th class="text-center backBlack" style="width:35%;border:1px solid #000 !important;">{{ lang.received_date }}</th>
                                    <th class="text-center backBlack" style="width:35%;border:1px solid #000 !important;">{{ lang.delivery_date }}</th>
                                    <th class="text-center backBlack" style="width:10%;border:1px solid #000 !important;">{{ lang.status }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="text-center" style="border:1px solid #000 !important;">{{ card.card_id }}</td>
                                    <td class="text-center" style="border:1px solid #000 !important;" v-if="card.received_date">{{ card.received_date.substring(0,10) }}</td>
                                    <td class="text-center" style="border:1px solid #000 !important;" v-else> - </td>
                                    <td class="text-center" style="border:1px solid #000 !important;" v-if="card.delivery_date">{{ card.delivery_date.substring(0,10) }}</td>
                                    <td class="text-center" style="border:1px solid #000 !important;" v-else> - </td>
                                    <td class="text-center" style="border:1px solid #000 !important;" :style="`background:${card._statusbg} !important;color:${card._statuscolor} !important`">{{ card['_status_'+lang.langname] }}</td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                        <v-simple-table>
                            <thead>
                                <tr v-if="card.customer_type == 1">
                                    <th style="width:80px;border:1px solid #000 !important;">{{ lang.customer_type }}</th>
                                    <td :style="`border:1px solid #000 !important;background:${card._customer_type_bgcolor} !important;color:${card._customer_type_color} !important;`">{{ card['_customer_type_'+lang.langname] }}</td>
                                    <th style="width:80px;border:1px solid #000 !important;">{{ lang.full_name }}</th>
                                    <td style="border:1px solid #000 !important;">{{ card.customer }}</td>
                                    <th style="width:80px;border:1px solid #000 !important;">{{ lang.mobile }}</th>
                                    <td style="width:80px;border:1px solid #000 !important;">{{ card.mobile }}</td>
                                </tr>
                                <!-- <tr v-if="card.customer_type == 1">
                                    <th style="width:80px;">{{ lang.id_number }}</th>
                                    <td >{{ card['id_number'] }}</td>
                                    <th style="width:80px;">{{ lang.owner_name }}</th>
                                    <td>{{ card.owner_name }}</td>
                                </tr> -->
                                <tr v-if="card.customer_type == 2">
                                    <th style="width:80px;border:1px solid #000 !important;;">{{ lang.customer_type }}</th>
                                    <td :style="`width:100px;border:1px solid #000 !important;background:${card._customer_type_bgcolor} !important;color:${card._customer_type_color} !important;`">{{ card['_customer_type_'+lang.langname] }}</td>
                                    <th style="width:80px;border:1px solid #000 !important;">{{ lang.company_name }}</th>
                                    <td style="width:80px;border:1px solid #000 !important;">{{ card.customer }}</td>
                                </tr>
                                <tr v-if="card.customer_type == 3">
                                    <th style="width:80px;border:1px solid #000 !important;">{{ lang.customer_type }}</th>
                                    <td :style="`border:1px solid #000 !important;background:${card._customer_type_bgcolor} !important;color:${card._customer_type_color} !important;`">{{ card['_customer_type_'+lang.langname] }}</td>
                                    <th style="width:80px;border:1px solid #000 !important;">{{ lang.company_name }}</th>
                                    <td style="width:80px;border:1px solid #000 !important;">{{ card.customer }}</td>
                                    <th style="border:1px solid #000 !important;width:80px;">{{ lang.mobile }}</th>
                                    <td>{{ card.mobile }}</td>
                                </tr>
                            </thead>
                        </v-simple-table>
                        <v-simple-table>
                            <thead>
                                <tr v-if="card.customer_type == 3">
                                    <th style="width:80px;border:1px solid #000 !important;width:80px;">{{ lang.branch_name }}</th>
                                    <td style="border:1px solid #000 !important;width:80px;">{{ card.client.branch_name }}</td>
                                    <th style="width:80px;border:1px solid #000 !important;width:80px;">{{ lang.order_number }}</th>
                                    <td style="border:1px solid #000 !important;width:80px;">{{ card.order_number }}</td>
                                    <th style="width:80px;border:1px solid #000 !important;width:80px;">{{ lang.request_number }}</th>
                                    <td style="border:1px solid #000 !important;width:80px;">{{ card.request_number }}</td>
                                </tr>
                            </thead>
                        </v-simple-table>
                        <v-simple-table>
                            <thead>
                                <tr v-if="card.customer_type == 3">
                                    <th style="width:80px;border:1px solid #000 !important;width:80px;">{{ lang.po_number }}</th>
                                    <td style="border:1px solid #000 !important;width:80px;">{{ card.po_number }}</td>
                                    <th style="width:80px;border:1px solid #000 !important;width:80px;">{{ lang.po_date }}</th>
                                    <td style="border:1px solid #000 !important;width:80px;">{{ card.po_date }}</td>
                                </tr>
                            </thead>
                        </v-simple-table>
                        <v-simple-table>
                            <thead>
                                <tr v-if="card.customer_type == 2">
                                    <th style="width:80px;border:1px solid #000 !important;width:80px;">{{ lang.mobile }}</th>
                                    <td style="border:1px solid #000 !important;width:80px;">{{ card.mobile }}</td>
                                    <th style="width:80px;border:1px solid #000 !important;width:80px;">{{ lang.company_vatid }}</th>
                                    <td style="border:1px solid #000 !important;width:80px;">{{ card.client.company_vatid }}</td>
                                    <th style="width:80px;border:1px solid #000 !important;width:80px;">{{ lang.crt_number }}</th>
                                    <td style="border:1px solid #000 !important;width:80px;">{{ card.client.crt_number }}</td>
                                </tr>
                                <tr v-if="card.customer_type == 2 && $store.state.licenseType.carInsuranceContract">
                                    <th style="width:80px;border:1px solid #000 !important;width:80px;">{{ lang.afforded_customer_name }}</th>
                                    <td style="border:1px solid #000 !important;width:80px;" colspan="5">{{ card.customer_name }}</td>
                                </tr>
                                <tr v-if="card.customer_type == 2">
                                    <th style="width:80px;border:1px solid #000 !important;width:80px;">{{ lang.po_number }}</th>
                                    <td style="border:1px solid #000 !important;width:80px;" colspan="2">{{ card.po_number }}</td>
                                    <th style="width:80px;border:1px solid #000 !important;width:80px;">{{ lang.po_date }}</th>
                                    <td style="border:1px solid #000 !important;width:80px;" colspan="2">{{ card.po_date }}</td>
                                </tr>
                            </thead>
                        </v-simple-table>
                        <v-simple-table>
                            <thead>
                                <tr v-if="card.customer_type == 2">
                                    <th style="width:80px;border:1px solid #000 !important;width:80px;">{{ lang.address }}</th>
                                    <td style="border:1px solid #000 !important;width:80px;">{{ address }}</td>
                                </tr>
                            </thead>
                        </v-simple-table>
                        <br />
                        <h6 v-if="card.maintenance_type === 'general'" style="background:lightblue;color:#000 !important;font-weight:bold;padding:3px;margin-bottom:10px;margin-top:10px;text-align:center;">{{ lang.device_info }}</h6>
                        <v-simple-table v-if="card.maintenance_type === 'general'">
                            <thead>
                                <tr>
                                    <th class="text-center backBlack" style="width:120px;">{{ lang.device_name }}</th>
                                    <td>{{ deviceInfo.device_name || deviceInfo.name }}</td>
                                    <th class="text-center backBlack" style="width:120px;">{{ lang.device_model }}</th>
                                    <td>{{ deviceInfo.device_model || deviceInfo.model }}</td>
                                    <th class="text-center backBlack" style="width:120px;">{{ lang.serial_number }}</th>
                                    <td>{{ deviceInfo.serial_number || deviceInfo.serial }}</td>
                                </tr>
                                <tr>
                                    <th class="text-center backBlack">{{ lang.device_accessories }}</th>
                                    <td colspan="2">{{ deviceInfo.accessories }}</td>
                                    <th class="text-center backBlack">{{ lang.device_received_status }}</th>
                                    <td colspan="2">{{ deviceInfo.received_status }}</td>
                                </tr>
                            </thead>
                        </v-simple-table>
                        <h6 v-if="$store.state.licenseType.cars && card.maintenance_type !== 'general'" style="background:lightblue;color:#000 !important;font-weight:bold;padding:3px;margin-bottom:10px;margin-top:10px;text-align:center;">{{ lang.car_info }}</h6>
                        <template v-if="card.maintenance_type !== 'general'">
                        <v-simple-table v-for="(item,index) in card.carsjson" :key="index">
                            <thead>
                                <tr>
                                    <th class="text-center backBlack" style="width:85px;">{{ lang.plate_number }}</th>
                                    <td>{{ item.plate_number }}</td>
                                    <th class="text-center backBlack" style="width:85px;">{{ lang.brand_name }}</th>
                                    <td>{{ item.brand }}</td>
                                    <th class="text-center backBlack" style="width:85px;">{{ lang.car_model }}</th>
                                    <td style="width:85px;">{{ item.model }}</td>
                                    <th class="text-center backBlack" style="width:85px;">{{ lang.car_year }}</th>
                                    <td>{{ item.made_year }}</td>
                                </tr>
                                <tr>
                                    <th class="text-center backBlack" style="width:85px;">{{ lang.car_color }}</th>
                                    <td>{{ item.color }}</td>
                                    <th class="text-center backBlack" style="width:85px;">{{ lang.engine_meter }}</th>
                                    <td v-if="item.engine_meter === 'undefined'">0</td>
                                    <td v-else>{{ item.engine_meter }}</td>
                                    <th class="text-center backBlack" style="width:85px;">{{ lang.vin_numebr }}</th>
                                    <td colspan="3">{{ item.vin }}</td>
                                </tr>
                                <tr><td style="background:none;border:none !important;"></td></tr>
                            </thead>
                        </v-simple-table>
                        </template>
                        <h6 style="background:lightblue;color:#000 !important;font-weight:bold;padding:3px;margin-bottom:10px;margin-top:10px;text-align:center;">{{ lang.terms_and_conditions }}</h6>
                        <v-simple-table>
                            <thead>
                                <tr>
                                    <th class="backBlack">{{ lang.terms }}</th>
                                    <!-- <th class="backBlack" style="width:80px;">{{lang.action}}</th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item,index) in terms" :key="index">
                                    <td>{{ item.terms }}</td>
                                    <!-- <td></td> -->
                                </tr>
                            </tbody>
                            <!-- <tfoot>
                                <tr>
                                    <th>
                                        <b-form-input class="inborder" v-model="iterms" />
                                    </th>
                                    <th>
                                        <v-btn @click="addTerms()" style="background:green;color:#fff;padding:3px !important;margin-top:3px;">{{ lang.add }}</v-btn>
                                    </th>
                                </tr>
                            </tfoot> -->
                        </v-simple-table>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" v-show="activePopCardTab === 'finance' || activePopCardTab === 'rest'">
                        <div v-show="activePopCardTab === 'finance'">
                        <h6 style="background:lightblue;color:#000 !important;font-weight:bold;padding:3px;margin-bottom:10px;margin-top:10px;text-align:center;">{{ lang.finance_report }}</h6>
                        <v-simple-table>
                            <thead>
                                <tr>
                                    <th class="text-center backBlack">{{ lang.total }}</th>
                                    <th class="text-center backBlack" v-if="$store.state.licenseType.carInsuranceContract">{{ lang.customer_afforded }}</th>
                                    <th class="text-center backBlack">{{ lang.per_discount }}</th>
                                    <th class="text-center backBlack" style="width:100px !important;">{{ lang.discount }} {{ lang.curency }}</th>
                                    <th class="text-center backBlack">{{ lang.vat }}</th>
                                    <th class="text-center backBlack">{{ lang.ftotal }}</th>
                                    <th class="text-center backBlack">{{ lang.paid }}</th>
                                    <th class="text-center backBlack">{{ lang.remain }}</th>
                                    <th class="text-center backBlack" v-for="(item,index) in rowType1" :key="index">{{ item.text }}</th>
                                    <th class="text-center backBlack">{{ lang.wins }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th class="text-center">{{ $convertToComa(card.total,$store.state.licenseType.moneyComma) }}</th>
                                    <th class="text-center" v-if="$store.state.licenseType.carInsuranceContract">{{ $convertToComa(card.customer_afforded,$store.state.licenseType.moneyComma) }}</th>
                                    <th class="text-center" v-if="$store.state.licenseType.canAddDiscountToCard"><b-form-input v-model="per_discount" @change="getDiscount()" class="inborder" /></th>
                                    <th class="text-center" v-else>{{ per_discount }}</th>
                                    <th class="text-center" style="width:100px !important;" v-if="$store.state.licenseType.canAddDiscountToCard"><b-form-input v-model="card.discount" @change="updateDiscount()" class="inborder" /></th>
                                    <th class="text-center" style="width:100px !important;" v-else>{{ card.discount }}</th>
                                    <th class="text-center">{{ $convertToComa($RoundNums(card.vat,2),$store.state.licenseType.moneyComma) }}</th>
                                    <th class="text-center">{{ $convertToComa($RoundNums(card.ftotal,2),$store.state.licenseType.moneyComma) }}</th>
                                    <th class="text-center">{{ $convertToComa($RoundNums(card.paid,2),$store.state.licenseType.moneyComma) }}</th>
                                    <th class="text-center">{{ $convertToComa($RoundNums(total_payment,2),$store.state.licenseType.moneyComma) }}</th>
                                    <th class="text-center" v-for="(item,index) in rowType1" :key="index">
                                        {{ cardType[`rowType_${item.value}`].total }}
                                    </th>
                                    <th class="text-center" style="background:green !important;color:#fff !important;">{{ total_profit }}</th>
                                </tr>
                            </tbody>
                        </v-simple-table>
                        <br />
                        <h6 style="background:lightblue;color:#000 !important;font-weight:bold;padding:3px;margin-bottom:10px;margin-top:10px;text-align:center;">{{ lang.payments }}</h6>
                        <v-simple-table>
                            <thead>
                                <tr>
                                    <th class="text-center backBlack">{{ lang.voucher_type }}</th>
                                    <th class="text-center backBlack">{{ lang.payment_date }}</th>
                                    <th class="text-center backBlack">{{ lang.payment_amount }}</th>
                                    <th class="text-center backBlack">{{ lang.payment_method }}</th>
                                    <th class="text-center backBlack" style="width:75px;">{{ lang.print }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr  v-for="(item,index) in card.payments" :key="index">
                                    <td class="text-center">{{ item[`_type_${lang.langname}`] }}</td>
                                    <td class="text-center">{{ item.receipt_date }}</td>
                                    <td class="text-center">{{ $convertToComa(item.ftotal,$store.state.licenseType.moneyComma) }}</td>
                                    <td class="text-center">{{ item['_paytype_'+lang.langname] }}</td>
                                    <td class="text-center"  @click="printPDF(item.id,2)" style="border:2px solid #fff;background:blue !important;color:#fff !important;cursor:pointer">{{ lang.print }}</td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                        <div style="display:flex;justify-content: space-between;background:lightblue;margin-top:5px;">
                            <h6 style="color:#000 !important;font-weight:bold;padding:3px;margin-bottom:10px;margin-top:10px;text-align:center;">{{ lang.ment_description }}</h6>
                            <div style="display:flex;align-items:center;gap:10px;font-weight:bold;padding:3px;">
                                <span>{{ lang.expected_hours || 'Expected Hours' }}: {{ formatHours(cardEstimatedHours) }}</span>
                            </div>
                            <v-btn style="background:green;color:#fff;padding:3px !important;margin-top:3px;" @click="openManageWorkersDialog">{{ lang.manage_workers }}</v-btn>
                        </div>
                        <v-simple-table>
                            <thead>
                                <tr>
                                    <th class="text-center backBlack" v-if="showCardPlateOnCard">{{ lang.plate_number }}</th>
                                    <th class="text-center backBlack" v-if="$store.state.licenseType.showtech1">{{ lang.worker_name }}</th>
                                    <th class="text-center backBlack">نوع الصنف</th>
                                    <!-- <th class="text-center backBlack">{{ lang.item_code }}</th> -->
                                    <th class="text-center backBlack">{{ lang.ment_description }}</th>
                                    <th class="text-center backBlack" style="width:100px;">{{ lang.expected_hours || 'Expected Hours' }}</th>
                                    <th class="text-center backBlack">{{ lang.total }}</th>
                                    <th class="text-center backBlack">{{ lang.status }}</th>
                                    <th class="text-center backBlack" colspan="3" v-if="card.invoiceid == 0 && $store.state.licenseType.updateCardDet" style="width:150px;">{{ lang.action }}</th>
                                    <th class="text-center backBlack" colspan="2" v-else-if="card.invoiceid == 0 && !$store.state.licenseType.updateCardDet" style="width:150px;">{{ lang.action }}</th>
                                    <th class="text-center backBlack" v-else style="width:80px;">{{ lang.action }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr  v-for="(item,index) in card.rows" :key="index">
                                    <td class="text-center" v-if="showCardPlateOnCard">{{ item.plate_number }}</td>
                                    <td class="text-center" style="white-space:pre-line;" v-if="$store.state.licenseType.showtech1 && !$store.state.licenseType.updateCardDet">{{ item.emp_name }}</td>

                                    <td class="text-center" style="white-space:pre-line;" v-if="$store.state.licenseType.showtech1">
                                        <div @click="showModal(3,index)" style="cursor:pointer;padding:2px;background:green;color:#fff;text-align:center;">اضافة/تعديل</div>
                                        <b-input-group style="display:none;">
                                            <b-form-select
                                            class="selborder"
                                            style="background:#eee !important;color:#000 !important;"
                                            :options="workers"
                                            multiple
                                            v-model="card.rows[index].empid">
                                        </b-form-select>
                                        <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                                            <i class="fas fa-arrow-down" style="color:#000"></i>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </td>
                                    <td class="text-center">
                                        <b-input-group>
                                        <b-form-select
                                            class="selborder"
                                            style="background:red !important"
                                            :options="staticOptions.itemTypes"
                                            v-model="card.rows[index].type_of_item">
                                        </b-form-select>
                                        <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                                            <i class="fas fa-arrow-down"></i>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </td>
                                    <!-- <td class="text-center">{{ item.itemcode }}</td> -->
                                    <td class="text-center" v-if="$store.state.licenseType.updateCardDet" :title="lang.item_code + `: ` + item.itemcode"><b-form-input class="inborder" v-model="card.rows[index].item_name" /></td>
                                    <td class="text-center" v-else :title="lang.item_code + `: ` + item.itemcode">{{ item.item_name }}</td>
                                    <td class="text-center" v-if="$store.state.licenseType.updateCardDet">
                                        <b-form-input class="inborder" type="number" min="0" step="0.25" v-model="card.rows[index].expected_hours" />
                                    </td>
                                    <td class="text-center" v-else>{{ formatHours(rowExpectedHours(item)) }}</td>
                                    <td class="text-center" v-if="$store.state.licenseType.updateCardDet"><b-form-input class="inborder" v-model="card.rows[index].ftotal" /></td>
                                    <td class="text-center" v-else>{{ $convertToComa(item.ftotal,$store.state.licenseType.moneyComma) }}</td>
                                    <td class="text-center" :style="`background:${item._rowStatus_bg} !important;color:${item._rowStatus_color} !important`">{{ item['_rowStatus_'+lang.langname] }}</td>
                                    <td class="text-center" v-if="$store.state.licenseType.updateCardDet && card.invoiceid == 0" @click="updateRows(index)" style="border:2px solid #fff !important;background:blue !important;color:#fff !important;cursor:pointer">{{lang.save}}</td>
                                    <td class="text-center" v-if="card.invoiceid == 0" @click="deleteRowx(item)" style="border:2px solid #fff !important;background:red !important;color:#fff !important;cursor:pointer">{{ lang.delete }}</td>
                                    <td class="text-center" v-if="item.status != 2" @click="finishRowx(item,0)" style="border:2px solid #fff !important;background:green !important;color:#fff !important;cursor:pointer">{{ lang.complete }}</td>
                                    <td class="text-center" v-else @click="finishRowx(item,1)" style="border:2px solid #fff !important;background:red !important;color:#fff !important;cursor:pointer">{{lang.maint_return}}</td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                        </div>
                        <div v-show="activePopCardTab === 'rest'">
                        <div v-for="(item,index) in rowType1" :key="index">

                            <h6 style="background:lightblue;color:#000 !important;font-weight:bold;padding:3px;margin-bottom:10px;margin-top:10px;text-align:center;">{{ item.text }}</h6>
                            <v-simple-table>
                                <thead>
                                    <tr>
                                        <th class="text-center backBlack" style="display:none;" v-if="showCardPlateOnCard">{{ lang.plate_number }}</th>
                                        <th class="text-center backBlack" v-if="$store.state.licenseType.showtech1">{{ lang.worker_name }}</th>
                                        <th class="text-center backBlack">{{ lang.description }}</th>
                                        <th class="text-center backBlack" style="width:80px;">{{ lang.qtty }}</th>
                                        <th class="text-center backBlack" style="width:80px;">{{ lang.total }}</th>
                                        <th class="text-center backBlack" style="width:75px;" v-if="card.invoiceid == 0">{{ lang.action }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr  v-for="(itm,key) in cardType[`rowType_${item.value}`].items" :key="key">
                                        <td class="text-center" style="display:none;" v-if="showCardPlateOnCard">{{ itm.plate_number }}</td>
                                        <td class="text-center" style="white-space:pre-line;" v-if="$store.state.licenseType.showtech1">{{ itm.emp_name }}</td>
                                        <td class="text-center" :title="lang.item_code + `: ` + itm.itemcode">{{ itm.item_name }}</td>
                                        <td class="text-center">{{ itm.qty }}</td>
                                        <td class="text-center">{{ $convertToComa(itm.ftotal,$store.state.licenseType.moneyComma) }}</td>
                                        <td class="text-center"  v-if="card.invoiceid == 0" @click="deleteRowx(itm)" style="border:2px solid #fff;background:red !important;color:#fff !important;cursor:pointer">{{ lang.delete }}</td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </div>
                        <div style="display:none">
                            <h6 style="background:lightblue;color:#000 !important;font-weight:bold;padding:3px;margin-bottom:10px;margin-top:10px;text-align:center;">{{ lang.expenses }}</h6>
                            <v-simple-table>
                                <thead>
                                    <tr>
                                        <th class="text-center backBlack" style="display:none;" v-if="showCardPlateOnCard">{{ lang.plate_number }}</th>
                                        <th class="text-center backBlack" v-if="$store.state.licenseType.showtech1">{{ lang.worker_name }}</th>
                                        <th class="text-center backBlack">{{ lang.ment_description }}</th>
                                        <th class="text-center backBlack">{{ lang.qtty }}</th>
                                        <th class="text-center backBlack">{{ lang.total }}</th>
                                        <th class="text-center backBlack" style="width:75px;" v-if="card.invoiceid == 0">{{ lang.action }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr  v-for="(item,index) in card.expense" :key="index">
                                        <td class="text-center" style="display:none;" v-if="showCardPlateOnCard">{{ item.plate_number }}</td>
                                        <td class="text-center" style="white-space:pre-line;" v-if="$store.state.licenseType.showtech1">{{ item.emp_name }}</td>
                                        <!-- <td class="text-center">{{ item.itemcode }}</td> -->
                                        <td class="text-center" :title="lang.item_code + `: ` + item.itemcode">{{ item.item_name }}</td>
                                        <td class="text-center">{{ item.qty }}</td>
                                        <td class="text-center">{{ $convertToComa(item.ftotal,$store.state.licenseType.moneyComma) }}</td>
                                        <td class="text-center"  v-if="card.invoiceid == 0" @click="deleteRowx(item)" style="border:2px solid #fff;background:red !important;color:#fff !important;cursor:pointer">{{ lang.delete }}</td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                            <h6 style="background:lightblue;color:#000 !important;font-weight:bold;padding:3px;margin-bottom:10px;margin-top:10px;text-align:center;">{{ lang.temporary_expenses}}</h6>
                            <v-simple-table>
                                <thead>
                                    <tr>
                                        <th class="text-center backBlack" style="display:none;" v-if="showCardPlateOnCard">{{ lang.plate_number }}</th>
                                        <th class="text-center backBlack" v-if="$store.state.licenseType.showtech1">{{ lang.worker_name }}</th>
                                        <th class="text-center backBlack">{{ lang.ment_description }}</th>
                                        <th class="text-center backBlack">{{ lang.qtty }}</th>
                                        <th class="text-center backBlack">{{ lang.total }}</th>
                                        <th class="text-center backBlack" style="width:75px;" v-if="card.invoiceid == 0">{{ lang.action }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr  v-for="(item,index) in card.tem_expense" :key="index">
                                        <td class="text-center" style="display:none;" v-if="showCardPlateOnCard">{{ item.plate_number }}</td>
                                        <td class="text-center" style="white-space:pre-line;" v-if="$store.state.licenseType.showtech1">{{ item.emp_name }}</td>
                                        <!-- <td class="text-center">{{ item.itemcode }}</td> -->
                                        <td class="text-center" :title="lang.item_code + `: ` + item.itemcode">{{ item.item_name }}</td>
                                        <td class="text-center">{{ item.qty }}</td>
                                        <td class="text-center">{{ $convertToComa(item.ftotal,$store.state.licenseType.moneyComma) }}</td>
                                        <td class="text-center"  v-if="card.invoiceid == 0" @click="deleteRowx(item)" style="border:2px solid #fff;background:red !important;color:#fff !important;cursor:pointer">{{ lang.delete }}</td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                            <h6 style="background:lightblue;color:#000 !important;font-weight:bold;padding:3px;margin-bottom:10px;margin-top:10px;text-align:center;">{{ lang.costs}}</h6>
                            <v-simple-table>
                                <thead>
                                    <tr>
                                        <th class="text-center backBlack" style="display:none;" v-if="showCardPlateOnCard">{{ lang.plate_number }}</th>
                                        <th class="text-center backBlack" v-if="$store.state.licenseType.showtech1">{{ lang.worker_name }}</th>
                                        <th class="text-center backBlack">{{ lang.ment_description }}</th>
                                        <th class="text-center backBlack">{{ lang.qtty }}</th>
                                        <th class="text-center backBlack">{{ lang.total }}</th>
                                        <th class="text-center backBlack" style="width:75px;" v-if="card.invoiceid == 0">{{ lang.action }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr  v-for="(item,index) in card.cost_expense" :key="index">
                                        <td class="text-center" style="display:none;" v-if="showCardPlateOnCard">{{ item.plate_number }}</td>
                                        <td class="text-center" style="white-space:pre-line;" v-if="$store.state.licenseType.showtech1">{{ item.emp_name }}</td>
                                        <!-- <td class="text-center">{{ item.itemcode }}</td> -->
                                        <td class="text-center" :title="lang.item_code + `: ` + item.itemcode">{{ item.item_name }}</td>
                                        <td class="text-center">{{ item.qty }}</td>
                                        <td class="text-center">{{ $convertToComa(item.ftotal,$store.state.licenseType.moneyComma) }}</td>
                                        <td class="text-center"  v-if="card.invoiceid == 0" @click="deleteRowx(item)" style="border:2px solid #fff;background:red !important;color:#fff !important;cursor:pointer">{{ lang.delete }}</td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </div>
                        </div>
                    </v-col>
                </v-row>
                <v-row :style="`direction:`+lang.dir" class="m-2" v-if="card.invoiceid == 0 && activePopCardTab === 'expenses_actions'">
                        <h6 style="background:lightblue;color:#000 !important;font-weight:bold;padding:3px;margin-bottom:10px;margin-top:10px;text-align:center;">{{ lang.add_new_work_expenses }}</h6>
                    <v-simple-table striped hover style="width:100%;">
                        <thead>
                            <tr>
                                <th class="text-center backBlack" style="width:140px;">{{lang.vat_type}}</th>
                                <th class="text-center backBlack" style="width:140px;">{{lang.row_type}}</th>
                                <th class="text-center backBlack" style="width:140px;" v-if="$store.state.licenseType.showtech1">{{lang.worker_name}}</th>
                                <th class="text-center backBlack" style="width:120px;" v-if="showCardPlateOnCard">{{lang.chose_car}}</th>
                                <th class="text-center backBlack" style="width:120px;">نوع الصنف</th>
                                <th class="backBlack" style="width:100px;" v-if="$store.state.licenseType.showItemCode">{{lang.item_code}}</th>
                                <th class="text-center backBlack">{{lang.description}}</th>
                                <th class="text-center backBlack" style="width:100px">{{ lang.expected_hours || 'Expected Hours' }}</th>
                                <th class="text-center backBlack" style="width:50px">{{lang.qtty}}</th>
                                <th class="text-center backBlack" style="width:100px">{{lang.item_price}}</th>
                                <th class="text-center backGreen" style="width:100px">{{lang.total}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <b-input-group>
                                    <b-form-select
                                        class="selborder"
                                        style="background:#eee !important;color:#000 !important;"
                                        :options="vattypes"
                                        v-model="newrow.vattype">
                                    </b-form-select>
                                    <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                                        <i class="fas fa-arrow-down" style="color:#000"></i>
                                        </b-input-group-append>
                                    </b-input-group>
                                </td>
                                <td>
                                    <b-input-group>
                                    <b-form-select
                                        class="selborder"
                                        style="background:#eee !important;color:#000 !important;"
                                        :options="rowType"
                                        v-model="newrow.type">
                                    </b-form-select>
                                    <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                                        <i class="fas fa-arrow-down" style="color:#000"></i>
                                        </b-input-group-append>
                                    </b-input-group>
                                </td>
                                <td v-if="$store.state.licenseType.showtech1">
                                    <div @click="showModal(5,0)" style="cursor:pointer;padding:2px;background:green;color:#fff;text-align:center;">اضافة/تعديل</div>
                                    <b-input-group style="display:none;">
                                        <b-form-select
                                        class="selborder"
                                        style="background:#eee !important;color:#000 !important;"
                                        :options="workers"
                                        multiple
                                        v-model="newrow.workers_name">
                                    </b-form-select>
                                    <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                                        <i class="fas fa-arrow-down" style="color:#000"></i>
                                        </b-input-group-append>
                                    </b-input-group>
                                </td>
                                <td v-if="showCardPlateOnCard">
                                    <b-input-group>
                                    <b-form-select
                                        class="selborder"
                                        style="background:#eee !important;color:#000 !important;"
                                        :options="currentCars"
                                        v-model="newrow.plate_number">
                                    </b-form-select>
                                    <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                                        <i class="fas fa-arrow-down" style="color:#000"></i>
                                        </b-input-group-append>
                                    </b-input-group>
                                </td>
                                <td class="text-center">
                                    <b-input-group>
                                    <b-form-select
                                        class="selborder"
                                        style="background:red !important"
                                        :options="staticOptions.itemTypes"
                                        v-model="newrow.type_of_item">
                                    </b-form-select>
                                    <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                                        <i class="fas fa-arrow-down"></i>
                                        </b-input-group-append>
                                    </b-input-group>
                                </td>
                                <td v-if="$store.state.licenseType.showItemCode">
                                    <b-form-input
                                        class="inborder"
                                        v-model="newrow.itemcode"
                                        @change="getProd(1,0)"
                                        >
                                    </b-form-input>
                                </td>
                                <td>
                                    <v-combobox
                                        v-model="newrow.item_name"
                                        :items="workdesk"
                                        small-chips
                                        @change="getItemCode()"
                                    ></v-combobox>
                                </td>
                                <td>
                                    <b-form-input
                                        class="inborder"
                                        type="number"
                                        min="0"
                                        step="0.25"
                                        v-model="newrow.expected_hours"
                                    ></b-form-input>
                                </td>
                                <td>
                                    <b-form-input
                                        class="inborder"
                                        style="width:50px;"
                                        v-model="newrow.qty"
                                        @change="calcKit()"
                                        id="newitemqty"
                                    ></b-form-input>
                                </td>
                                <td>
                                    <b-form-input
                                        class="inborder"
                                        style="width:75px;"
                                        v-model="newrow.item_price"
                                        @change="calcKit()"
                                    ></b-form-input>
                                </td>
                                <td>
                                    <b-form-input
                                        class="inborder"
                                        v-model="newrow.total"
                                        @change="calcKit()"
                                        readonly
                                    ></b-form-input>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="11" class="text-end" style="border-left:none !important;border-right:none !important;border-bottom:none !important">
                                    <v-btn id="addNewRow" @click="addNewRow()" style="background:green;color:#fff;padding:3px !important;margin-top:3px;">{{ lang.add }}</v-btn>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-row>

                <v-row :style="`direction:`+lang.dir" class="m-2" v-show="activePopCardTab === 'expenses_actions'">
                    <h6 style="background:lightblue;color:#000 !important;font-weight:bold;padding:3px;margin-bottom:10px;margin-top:10px;text-align:center;">{{ lang.action }}</h6>
                    <v-simple-table striped hover style="width:100%;">
                        <thead>
                            <tr>
                                <th class="text-center backBlack" style="width:140px;">{{lang.vat_type}}</th>
                                <th class="text-center backBlack" style="width:140px;">{{lang.row_type}}</th>
                                <th class="text-center backBlack" style="width:140px;" v-if="$store.state.licenseType.showCardPayType">{{lang.payment_method}}</th>
                                <th class="text-center backBlack" style="width:140px;" v-if="$store.state.licenseType.showtech1">{{lang.worker_name}}</th>
                                <th class="text-center backBlack" style="width:120px;" v-if="showCardPlateOnCard">{{lang.chose_car}}</th>
                                <th class="backBlack" style="width:100px;" v-if="$store.state.licenseType.showItemCode && $store.state.licenseType.useItemCode">{{lang.item_code}}</th>
                                <th class="backBlack" style="width:100px;" v-if="$store.state.licenseType.showItemCode && !$store.state.licenseType.useItemCode">{{lang.purchase_inv}}</th>
                                <th class="text-center backBlack">{{lang.item_name}}</th>
                                <th class="text-center backBlack" style="width:50px">{{lang.qtty}}</th>
                                <th class="text-center backBlack" style="width:100px">{{lang.item_price}}</th>
                                <th class="text-center backGreen" style="width:100px">{{lang.total}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <b-input-group>
                                    <b-form-select
                                        class="selborder"
                                        style="background:#eee !important;color:#000 !important;"
                                        :options="vattypes"
                                        v-model="newrow1.vattype">
                                    </b-form-select>
                                    <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                                        <i class="fas fa-arrow-down" style="color:#000"></i>
                                        </b-input-group-append>
                                    </b-input-group>
                                </td>
                                <td>
                                    <b-input-group>
                                    <b-form-select
                                        class="selborder"
                                        style="background:#eee !important;color:#000 !important;"
                                        :options="rowType1"
                                        v-model="newrow1.type">
                                    </b-form-select>
                                    <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                                        <i class="fas fa-arrow-down" style="color:#000"></i>
                                        </b-input-group-append>
                                    </b-input-group>
                                </td>
                                <td v-if="$store.state.licenseType.showCardPayType">

                                    <b-input-group>
                                    <b-form-select
                                        class="selborder"
                                        style="background:#eee !important;color:#000 !important;"
                                        :options="payTypes"
                                        v-model="newrow1.paytype">
                                    </b-form-select>
                                    <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                                        <i class="fas fa-arrow-down" style="color:#000"></i>
                                        </b-input-group-append>
                                    </b-input-group>
                                </td>
                                <td v-if="$store.state.licenseType.showtech1">
                                    <div @click="showModal(4,0)" style="cursor:pointer;padding:2px;background:green;color:#fff;text-align:center;">اضافة/تعديل</div>
                                    <b-input-group style="display:none;">
                                    <b-form-select
                                        class="selborder"
                                        style="background:#eee !important;color:#000 !important;"
                                        :options="workers"
                                        multiple
                                        v-model="newrow1.workers_name">
                                    </b-form-select>
                                    <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                                        <i class="fas fa-arrow-down" style="color:#000"></i>
                                        </b-input-group-append>
                                    </b-input-group>
                                </td>
                                <td v-if="showCardPlateOnCard">
                                    <b-input-group>
                                    <b-form-select
                                        class="selborder"
                                        style="background:#eee !important;color:#000 !important;"
                                        :options="currentCars"
                                        v-model="newrow1.plate_number">
                                    </b-form-select>
                                    <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                                        <i class="fas fa-arrow-down" style="color:#000"></i>
                                        </b-input-group-append>
                                    </b-input-group>
                                </td>
                                <td v-if="$store.state.licenseType.showItemCode && $store.state.licenseType.useItemCode">
                                    <b-form-input
                                        class="inborder"
                                        v-model="newrow1.itemcode"
                                        @change="getProd(1,1)"
                                        >
                                    </b-form-input>
                                </td>
                                <td v-if="$store.state.licenseType.showItemCode && !$store.state.licenseType.useItemCode">
                                    <b-form-input
                                        class="inborder"
                                        v-model="newrow1.inv_id"
                                        @change="getProd(2,1)"
                                        >
                                    </b-form-input>
                                </td>
                                <td>
                                    <v-combobox
                                        v-model="newrow1.item_name"
                                        :items="products"
                                        small-chips
                                        @change="getItemCode1()"
                                    ></v-combobox>
                                </td>
                                <td>
                                    <b-form-input
                                        class="inborder"
                                        style="width:50px;"
                                        v-model="newrow1.qty"
                                        @change="calcKit1()"
                                        id="newitemqty"
                                    ></b-form-input>
                                </td>
                                <td>
                                    <b-form-input
                                        class="inborder"
                                        style="width:75px;"
                                        v-model="newrow1.item_price"
                                        @change="calcKit1()"
                                    ></b-form-input>
                                </td>
                                <td>
                                    <b-form-input
                                        class="inborder"
                                        v-model="newrow1.total"
                                        @change="calcKit1()"
                                        readonly
                                    ></b-form-input>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="9" class="text-end" style="border-left:none !important;border-right:none !important;border-bottom:none !important">
                                    <v-btn id="addNewRow1" @click="addNewRow1()" style="background:green;color:#fff;padding:3px !important;margin-top:3px;">{{ lang.add }}</v-btn>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-row>
                <v-row :style="`direction:`+lang.dir" class="m-2" v-show="activePopCardTab === 'spare_parts'">
                    <v-col cols="12">
                        <h6 style="background:lightblue;color:#000 !important;font-weight:bold;padding:3px;margin-bottom:10px;margin-top:10px;text-align:center;">{{ lang.request_spare_parts_items || lang.request_spare_parts || 'Request Spare Parts Items' }}</h6>
                    </v-col>
                    <v-col cols="12" md="6" sm="12">
                        <label>{{ lang.item_name || 'Item Name' }}</label>
                        <b-form-input class="inborder" v-model="spareRequestForm.item_name"></b-form-input>
                    </v-col>
                    <v-col cols="12" md="2" sm="12">
                        <label>{{ lang.qtty || 'Quantity' }}</label>
                        <b-form-input class="inborder" type="number" min="1" step="1" v-model="spareRequestForm.quantity"></b-form-input>
                    </v-col>
                    <v-col cols="12" md="4" sm="12" class="d-flex align-items-end">
                        <v-btn color="green" dark class="mr-2" @click="createPartRequest">{{ lang.add || 'Add' }}</v-btn>
                        <v-btn color="primary" dark @click="loadPartRequests">{{ lang.refresh || 'Refresh' }}</v-btn>
                    </v-col>

                    <v-col cols="12" class="mt-2">
                        <v-simple-table>
                            <thead>
                                <tr>
                                    <th class="text-center backBlack">{{ lang.item_name || 'Item Name' }}</th>
                                    <th class="text-center backBlack">{{ lang.qtty || 'Quantity' }}</th>
                                    <th class="text-center backBlack">{{ lang.status || 'Status' }}</th>
                                    <th class="text-center backBlack">{{ lang.done || 'Done' }}</th>
                                    <th class="text-center backBlack">{{ lang.availability || 'Availability' }}</th>
                                    <th class="text-center backBlack">{{ lang.created_date || 'Date' }}</th>
                                    <th class="text-center backBlack">{{ lang.action || 'Action' }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(req, idx) in sparePartRequests" :key="idx">
                                    <td class="text-center">{{ req.item_name }}</td>
                                    <td class="text-center">{{ req.quantity }}</td>
                                    <td class="text-center">{{ formatRequestStatus(req.status) }}</td>
                                    <td class="text-center">
                                        <span v-if="isRequestDone(req)" style="color:green;font-weight:bold;">{{ lang.done || 'Done' }}</span>
                                        <span v-else style="color:#c0392b;font-weight:bold;">{{ lang.not_done || 'Not Done' }}</span>
                                    </td>
                                    <td class="text-center">
                                        <span v-if="isInventorySystemActive()">
                                            <span v-if="req.inventory_status === 'available'" style="color:green;font-weight:bold;">In-Stock</span>
                                            <span v-else-if="req.inventory_status === 'out_of_stock'" style="color:red;font-weight:bold;">Out of Stock</span>
                                            <span v-else>{{ req.inventory_status }}</span>
                                        </span>
                                        <span v-else>Manual Review Required</span>
                                    </td>
                                    <td class="text-center">{{ req.created_date }}</td>
                                    <td class="text-center">
                                        <div v-if="canDeliverPartRequest(req)">
                                            <v-btn
                                                x-small
                                                color="primary"
                                                dark
                                                :loading="requestActionId === Number(req.id)"
                                                :disabled="requestActionId !== 0"
                                                @click="deliverPartRequest(req)"
                                            >
                                                {{ lang.deliver_spare_part || lang.delivered || 'Deliver Part' }}
                                            </v-btn>
                                        </div>
                                        <div v-else-if="canAcknowledgeRequest(req)">
                                            <v-btn
                                                x-small
                                                color="success"
                                                dark
                                                class="mr-1"
                                                :loading="requestActionId === Number(req.id)"
                                                :disabled="requestActionId !== 0"
                                                @click="acknowledgePartRequest(req,'fulfilled')"
                                            >
                                                {{ lang.received || 'Received' }}
                                            </v-btn>
                                            <v-btn
                                                x-small
                                                color="error"
                                                dark
                                                :disabled="requestActionId !== 0"
                                                @click="acknowledgePartRequest(req,'rejected')"
                                            >
                                                {{ lang.decline || 'Decline' }}
                                            </v-btn>
                                        </div>
                                        <span v-else-if="String(req.status || '').toLowerCase() === 'approved'">
                                            {{ lang.waiting_technician_receipt || 'Waiting for technician receipt' }}
                                        </span>
                                        <span v-else>-</span>
                                    </td>
                                </tr>
                                <tr v-if="!sparePartRequests.length">
                                    <td class="text-center" colspan="7">{{ lang.no_data || 'No data' }}</td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                </v-row>
                <v-row v-if="$store.state.licenseType.cars && card.maintenance_type !== 'general' && activePopCardTab === 'rest'" :style="`direction:`+lang.dir" class="m-2">
                    <h6 style="background:lightblue;color:#000 !important;font-weight:bold;padding:3px;margin-bottom:10px;margin-top:10px;text-align:center;">{{ lang.car_status_receive }}</h6>
                    <v-col cols="12" md="6" sm="12" v-for="(image,index) in carStatus.images" :key="index">
                        <div style="border:1px solid #000" class="backBlack">{{ image.plate }}</div>
                        <v-row>
                            <v-col cols="12" md="4" sm="12">
                                <div style="border:1px solid #000"><img :src="image.image" style="width:100%"></div>
                            </v-col>
                            <v-col cols="12" md="8" sm="12">
                                <v-simple-table v-for="(items,indo) in carStatus.status" :key="indo">
                                    <tr v-if="items.plate == image.plate">
                                        <td >{{ items.text }}</td>
                                    </tr>
                                </v-simple-table>
                            </v-col>
                        </v-row>

                    </v-col>
                </v-row>

                <v-dialog v-model="manageWorkersDialog" max-width="1500" persistent>
                    <v-card>
                        <v-card-title class="headline">
                            {{ lang.manage_workers || 'Manage Workers' }}
                        </v-card-title>
                        <v-card-text>
                            <v-simple-table>
                                <thead>
                                    <tr>
                                        <th class="text-center">{{ lang.worker_name || 'Worker' }}</th>
                                        <th class="text-center">{{ lang.ment_description || 'Row Item' }}</th>
                                        <th class="text-center">{{ lang.notes || 'Notes' }}</th>
                                        <th class="text-center">{{ lang.expected_hours || 'Expected Hours' }}</th>
                                        <th class="text-center">{{ lang.current_load || 'Current Load' }}</th>
                                        <th class="text-center">{{ lang.projected_load || 'With This' }}</th>
                                        <th class="text-center">{{ lang.estimated_finish || 'Finish' }}</th>
                                        <th class="text-center">{{ lang.percentage || 'Percentage' }}</th>
                                        <th class="text-center" style="width:90px;">{{ lang.action || 'Action' }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(assignment, index) in workerAssignments" :key="assignment.key">
                                        <td>
                                            <v-select
                                                dense
                                                outlined
                                                :items="workerOptions"
                                                item-text="text"
                                                item-value="value"
                                                v-model="assignment.workerId"
                                                @change="onAssignmentChanged(index)"
                                            />
                                        </td>
                                        <td>
                                            <v-select
                                                dense
                                                outlined
                                                :items="rowItemOptions"
                                                item-text="text"
                                                item-value="value"
                                                v-model="assignment.rowId"
                                                @change="onAssignmentChanged(index)"
                                            />
                                        </td>
                                        <td>
                                            <b-form-input
                                                class="inborder"
                                                v-model="assignment.notes"
                                            />
                                        </td>
                                        <td>
                                            <b-form-input
                                                class="inborder"
                                                type="number"
                                                min="0"
                                                step="0.01"
                                                v-model="assignment.expected_hours"
                                            />
                                        </td>
                                        <td class="text-center">{{ formatHours(getWorkerWorkload(assignment.workerId).remaining_hours) }}</td>
                                        <td class="text-center">{{ formatHours(projectedAssignmentHours(assignment)) }}</td>
                                        <td class="text-center">{{ projectedAssignmentFinish(assignment) }}</td>
                                        <td>
                                            <b-form-input
                                                class="inborder"
                                                type="number"
                                                min="0"
                                                max="100"
                                                step="0.01"
                                                v-model="assignment.percentage"
                                            />
                                        </td>
                                        <td class="text-center">
                                            <v-btn icon color="error" @click="removeAssignmentRow(index)">
                                                <v-icon small>mdi-delete</v-icon>
                                            </v-btn>
                                        </td>
                                    </tr>
                                </tbody>
                            </v-simple-table>

                            <div class="mt-2">
                                <v-btn small color="primary" @click="addAssignmentRow">
                                    <v-icon small class="mr-1">mdi-plus</v-icon>
                                    {{ lang.add || 'Add' }}
                                </v-btn>
                            </div>
                        </v-card-text>
                        <v-card-actions class="justify-end">
                            <v-btn text @click="manageWorkersDialog = false">{{ lang.close || 'Close' }}</v-btn>
                            <v-btn color="green" dark @click="saveManageWorkersAssignments">{{ lang.save || 'Save' }}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </template>
        </b-sidebar>

        <AddCardPayment ref="cardPayments" />
        <addInvoice ref="addInvoice" />
        <viewCardGallery ref="viewCardGall" />
        <sendCardWhats ref="sendCardWhats" />
        <NewCardTecs ref="showModal" />
        <updateCardInfo ref="updateCardInfo" />
    </div>
</template>

<script>
import axios from 'axios'

import {SnotifyPosition} from 'vue-snotify';
import AddCardPayment from '@/components/addCardPayment.vue'
import addInvoice from '@/components/addInvoice.vue'
import viewCardGallery from '@/components/viewCardGallery.vue'
import sendCardWhats from '@/components/sendCardWhats.vue'
import NewCardTecs from '@/components/NewCardTecs.vue'
import updateCardInfo from '@/components/updateCardInfo.vue'

export default {
    components:{AddCardPayment,addInvoice,viewCardGallery,sendCardWhats, NewCardTecs,updateCardInfo},
    data() {
        return {
            activePopCardTab: 'finance',
            work_type: 1,
            terms: [],
            iterms: '',
            cardid: 0,
            card: {},
            showButtons: true,
            newrow:{
                vattype: 3,
                empname: '',
                itemcode: '',
                item_name: '',
                qty: 1,
                item_price: '',
                total: '',
                vat: '',
                ftotal: '',
                plate_number: '',
                workers_name: [],
                expected_hours: '',
                type: 1,
                itemid: 0,
                stype: 'service',
                type_of_item: 1,
            },
            newrow1:{
                vattype: 3,
                empname: '',
                itemcode: '',
                item_name: '',
                qty: 1,
                item_price: '',
                total: '',
                vat: '',
                ftotal: '',
                plate_number: '',
                workers_name: [],
                type: 1,
                itemid: 0,
                stype: 'spareparts',
                inv_id: '',
                paytype: 0,
            },
            workers:[],
            currentCars:[],
            vattypes:[],
            rowType:[],
            rowType1:[],
            products:[],
            workdesk: [],
            allProducts: [],
            allWorks: [],
            pTypes: [],
            per_discount: '',
            static_options: [],
            manageWorkersDialog: false,
            customerCaseLink: '',
            generatingCustomerLink: false,
            workerAssignments: [],
            technicianWorkloads: {},
            workloadLoading: false,
            sparePartRequests: [],
            requestActionId: 0,
            spareRequestForm: {
                item_name: '',
                quantity: 1,
            },
            cardType: {
                rowType_2: {options: {}, items: []}
            }
        }
    },
    computed:{
        total_profit: function(){

            let t = parseFloat(this.card.total) - parseFloat(this.card.discount) - parseFloat(this.card.customer_afforded);
            for(let i=0;i<this.rowType1.length;i++){
                let val = this.rowType1[i].value;
                if(this.cardType[`rowType_${val}`].options.cost == 1){
                    t = parseFloat(t) - parseFloat(this.cardType[`rowType_${val}`].total)
                }
                if(this.cardType[`rowType_${val}`].options.profit == 1){
                    t = parseFloat(t) + parseFloat(this.cardType[`rowType_${val}`].total)
                }
            }
            return this.$RoundNums(t,2);
        },
        total_payment: function(){
            let t = parseFloat(this.card.ftotal) - parseFloat(this.card.paid);
            for(let i=0;i<this.rowType1.length;i++){
                let val = this.rowType1[i].value;
                if(this.cardType && this.cardType[`rowType_${val}`] && this.cardType[`rowType_${val}`].options){
                    if(this.cardType[`rowType_${val}`].options.rowtype == "Payment"){
                        t = parseFloat(t) + parseFloat(this.cardType[`rowType_${val}`].total)
                    }
                }
            }
            return this.$RoundNums(t,2);
        },
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        staticOptions: function () {
            let t = {};
            Object.keys(this.static_options).forEach((key) => {
                t[key] = []; // initialize array for each key

                for (let i = 0; i < this.static_options[key].length; i++) {
                    t[key].push({
                        text: this.static_options[key][i][`name_${this.lang.langname}`],
                        value: this.static_options[key][i].value
                    });
                }
            });

            return t;
        },
        address: function(){
            let t = "";
            if(this.card.client.address != '') {
                t = this.card.client.address;
            }else{
                t = this.card.client.building_no + " " + this.card.client.street_name + " ";
                t = t + this.card.client.branch_number + " - " + this.card.client.zipcode + " ";
                t = t + this.card.client.district + " - " + this.card.client.city;
            }
            return t;
        },
        sumTotals: function()
        {
            let t= {
                rows: [],
                full_profit: 0
            }

            return t;
        },
        remain: function(){
            let t = this.card.ftotal;
            if(this.card.paid != 0 && this.card.paid != '') {
                t = parseFloat(t) - parseFloat(this.card.paid)
            }
            return t;
        },
        deviceInfo: function(){
            if(this.card && this.card.device_info && typeof this.card.device_info === 'object') {
                return this.card.device_info;
            }
            return {};
        },
        showCardPlateOnCard: function(){
            return this.$store.state.licenseType.showCarPlate && this.card.maintenance_type !== 'general';
        },
        carStatus: function(){
            let t = {images: [],status: []};
            const cardCars = Array.isArray(this.card._cars) ? this.card._cars : [];
            const cardImages = Array.isArray(this.card.images) ? this.card.images : [];
            const cardStatuses = Array.isArray(this.card.status) ? this.card.status : [];
            for(let i=0;i<cardCars.length;i++){
                let hasimg = false;
                for(let j=0;j<cardImages.length;j++){
                    if(cardCars[i].plate_number == cardImages[j].plate_number){
                        hasimg = true;
                        t.images.push({
                            image: cardImages[j].bvalue,
                            plate: cardImages[j].plate_number,
                        })
                    }
                }
                for(let j=0;j<cardStatuses.length;j++){

                    if(cardCars[i].plate_number == cardStatuses[j].plate_number){
                        t.status.push({
                            text: cardStatuses[j].bvalue,
                            plate: cardStatuses[j].plate_number,
                        })
                    }
                }
                if(!hasimg){
                    t.images.push({
                        image: './img/car-background.png',
                        plate: cardCars[i].plate_number
                    })
                }
            }
            return t;
        },
        payTypes: function() {
            return this.pTypes
        },
        workerOptions: function() {
            if(!Array.isArray(this.workers)) return [];
            return this.workers.map((worker) => {
                const value = String(worker.value || worker.id || '');
                return {
                    ...worker,
                    workload: this.getWorkerWorkload(value)
                }
            });
        },
        rowItemOptions: function() {
            if(!this.card || !Array.isArray(this.card.rows)) return [];
            return this.card.rows.map((row) => ({
                value: String(row.id),
                text: `${row.item_name || ''}${row.plate_number ? ' - ' + row.plate_number : ''}`
            }));
        },
        cardEstimatedHours: function() {
            if(!this.card || !Array.isArray(this.card.rows)) return 0;
            return this.card.rows.reduce((total, row) => {
                return total + Number(this.rowExpectedHours(row) || 0);
            }, 0);
        }
    },
    created() {
        //setInterval(() => {this.calckInv();},10000);
        this.getUsers();
        this.getStatic();
        this.getProducts();
        this.getPyamentType();
    },
    methods: {
        setActivePopCardTab(tabName) {
            this.activePopCardTab = tabName;
        },
        showFormError(message) {
            this.$snotify.error(message, this.lang.alert, {
                timeout: 4000,
                showProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                position: SnotifyPosition.centerCenter,
                buttons: [
                    {
                        text: this.lang.close,
                        action: (toast) => {
                            this.$snotify.remove(toast.id);
                        }
                    },
                ]
            });
        },
        estimatedHoursRequiredMessage() {
            return this.lang.expected_hours_required || 'Estimated hours are required for maintenance work';
        },
        defaultWorkload(employeeId = '') {
            return {
                employee_id: employeeId,
                active_tasks: 0,
                open_tasks: 0,
                paused_tasks: 0,
                expected_hours: 0,
                working_hours: 0,
                remaining_hours: 0,
                queue: [],
            };
        },
        getWorkerWorkload(workerId) {
            const key = String(workerId || '');
            return (this.technicianWorkloads && this.technicianWorkloads[key]) ? this.technicianWorkloads[key] : this.defaultWorkload(key);
        },
        formatHours(value) {
            const hours = Number(value || 0);
            if(!Number.isFinite(hours)) return '0 h';
            const rounded = Math.round(hours * 100) / 100;
            return `${rounded} h`;
        },
        formatProjectedFinish(totalHours) {
            const hours = Number(totalHours || 0);
            if(!Number.isFinite(hours) || hours <= 0) return '-';
            const finish = new Date(Date.now() + (hours * 60 * 60 * 1000));
            return finish.toLocaleString();
        },
        projectedAssignmentHours(assignment) {
            if(!assignment || !assignment.workerId) return 0;
            const workload = this.getWorkerWorkload(assignment.workerId);
            return Number(workload.remaining_hours || 0) + Number(assignment.expected_hours || 0);
        },
        projectedAssignmentFinish(assignment) {
            return this.formatProjectedFinish(this.projectedAssignmentHours(assignment));
        },
        rowExpectedHours(row) {
            if(!row) return 0;
            const rowHours = Number(row.expected_hours || 0);
            if(rowHours > 0) return rowHours;
            const rowId = String(row.id || '');
            const assignments = Array.isArray(this.card && this.card.worker_assignments) ? this.card.worker_assignments : [];
            return assignments
                .filter((item) => String(item.row_id || '') === rowId)
                .reduce((maxHours, item) => Math.max(maxHours, Number(item.expected_hours || 0)), 0);
        },
        async loadTechnicianWorkload() {
            const employeeIds = (Array.isArray(this.workers) ? this.workers : [])
                .map((worker) => worker.value || worker.id)
                .filter(Boolean);
            if(!employeeIds.length) {
                this.technicianWorkloads = {};
                return;
            }

            this.workloadLoading = true;
            try {
                const post = new FormData();
                post.append('defBranch', localStorage.getItem('defBranch'));
                post.append('financeYear', localStorage.getItem('financeYear'));
                post.append('type', 'getTechnicianWorkloadSummary');
                post.append('auth', this.$cookies.get(this.$store.state.COOKIEPhase));
                post.append('data[lang]', this.$cookies.get(this.$store.state.LangCooki));
                post.append('data[employee_ids]', employeeIds.join(','));
                if(this.card && this.card.id) {
                    post.append('data[exclude_cardid]', this.card.id);
                }

                const response = await axios.post(this.$store.state.SAMCOTEC.r_path, post);
                if(response && response.data && response.data.error && response.data.error.number === 200) {
                    const byEmployee = response.data.results.by_employee || {};
                    const normalized = {};
                    Object.keys(byEmployee).forEach((key) => {
                        normalized[String(key)] = byEmployee[key];
                    });
                    this.technicianWorkloads = normalized;
                }
            } finally {
                this.workloadLoading = false;
            }
        },
        isInventorySystemActive() {
            const settings = (this.$store && this.$store.state && this.$store.state.settings) ? this.$store.state.settings : {};
            const licenseType = (this.$store && this.$store.state && this.$store.state.licenseType) ? this.$store.state.licenseType : {};
            const activeValue = settings.is_inventory_active ?? settings.inventory_active ?? licenseType.is_inventory_active ?? licenseType.inventoryActive ?? 0;
            return Number(activeValue) === 1;
        },
        async loadPartRequests() {
            if(!this.card || !this.card.id) {
                this.sparePartRequests = [];
                return;
            }
            const post = new FormData();
            post.append('defBranch', localStorage.getItem('defBranch'));
            post.append('financeYear', localStorage.getItem('financeYear'));
            post.append('type', 'get_requests_list');
            post.append('auth', this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[job_card_id]', this.card.id);
            post.append('data[lang]', this.$cookies.get(this.$store.state.LangCooki));

            const response = await axios.post(this.$store.state.SAMCOTEC.r_path, post);
            if(response && response.data && response.data.error && response.data.error.number === 200){
                const requests = response.data.results && Array.isArray(response.data.results.data)
                    ? response.data.results.data
                    : [];
                this.sparePartRequests = requests.map((request) => ({
                    ...request,
                    id: Number(request.id || request.request_id || 0)
                }));
            }
        },
        async createPartRequest() {
            const item_name = (this.spareRequestForm.item_name || '').trim();
            const quantity = Number(this.spareRequestForm.quantity || 0);

            if(!this.card || !this.card.id || !item_name || quantity <= 0){
                return false;
            }

            const post = new FormData();
            post.append('defBranch', localStorage.getItem('defBranch'));
            post.append('financeYear', localStorage.getItem('financeYear'));
            post.append('type', 'create_part_request');
            post.append('auth', this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[lang]', this.$cookies.get(this.$store.state.LangCooki));
            post.append('data[job_card_id]', this.card.id);
            post.append('data[requested_by_id]', this.currentUserId());
            post.append('data[item_name]', item_name);
            post.append('data[quantity]', quantity);
            post.append('data[is_inventory_active]', this.isInventorySystemActive() ? 1 : 0);

            const response = await axios.post(this.$store.state.SAMCOTEC.r_path, post);
            if(response && response.data && response.data.error && response.data.error.number === 200){
                this.spareRequestForm.item_name = '';
                this.spareRequestForm.quantity = 1;
                await this.getCard(this.card.id, 'spare_parts');
            }
        },
        formatRequestStatus(status) {
            const val = String(status || '').toLowerCase();
            if(val === 'pending') return this.lang.pending || 'Pending';
            if(val === 'approved') return this.lang.approved || 'Approved';
            if(val === 'ordered') return this.lang.purchase_order || 'Ordered';
            if(val === 'fulfilled') return this.lang.received || 'Received';
            if(val === 'rejected') return this.lang.rejected || 'Rejected';
            return status || '-';
        },
        isRequestDone(req) {
            const status = String((req && req.status) ? req.status : '').toLowerCase();
            return status === 'fulfilled';
        },
        canAcknowledgeRequest(req) {
            if(!req || !req.id) return false;
            const currentUserId = this.currentUserId();
            const requesterId = Number(req.requested_by_id || 0);
            const status = String(req.status || '').toLowerCase();
            return currentUserId > 0 && requesterId === currentUserId && (status === 'ordered' || status === 'approved');
        },
        canDeliverPartRequest(req) {
            if(!req) return false;
            const requestId = Number(req.id || req.request_id || 0);
            const currentUserId = this.currentUserId();
            const requesterId = Number(req.requested_by_id || 0);
            const groupId = this.currentGroupId();
            const status = String(req.status || '').toLowerCase();
            const actionableStatus = status === 'pending' || status === 'ordered';

            if(groupId === 6) {
                return requestId > 0 && actionableStatus;
            }

            return requestId > 0 && currentUserId > 0 && requesterId !== currentUserId && actionableStatus;
        },
        currentUserId() {
            const userinfo = this.$store.state.userinfo && typeof this.$store.state.userinfo === 'object'
                ? this.$store.state.userinfo
                : {};
            return Number(userinfo.id || userinfo.userid || 0);
        },
        currentGroupId() {
            const userinfo = this.$store.state.userinfo && typeof this.$store.state.userinfo === 'object'
                ? this.$store.state.userinfo
                : {};
            return Number(this.$store.state.group_id || userinfo.group_id || userinfo.groupId || 0);
        },
        async deliverPartRequest(req) {
            if(!this.canDeliverPartRequest(req) || this.requestActionId !== 0) return false;

            const confirmText = this.lang.confirm_deliver_spare_part || 'Confirm that this spare part was delivered to the technician?';
            if(!window.confirm(confirmText)) return false;

            this.requestActionId = Number(req.id);
            try {
                const post = new FormData();
                post.append('defBranch', localStorage.getItem('defBranch'));
                post.append('financeYear', localStorage.getItem('financeYear'));
                post.append('type', 'update_request_status');
                post.append('auth', this.$cookies.get(this.$store.state.COOKIEPhase));
                post.append('data[request_id]', req.id);
                post.append('data[status]', 'approved');
                post.append('data[note]', 'Spare part delivered to technician from job card');

                const response = await axios.post(this.$store.state.SAMCOTEC.r_path, post);
                if(response && response.data && response.data.error && response.data.error.number === 200){
                    await this.getCard(this.card.id, 'spare_parts');
                }
            } finally {
                this.requestActionId = 0;
            }
        },
        async acknowledgePartRequest(req, status) {
            if(!req || !req.id || !this.canAcknowledgeRequest(req) || this.requestActionId !== 0) return false;

            if(status === 'rejected'){
                const confirmText = this.lang.confirm_decline_spare_request || this.lang.confirm_delete || 'Are you sure you want to decline receiving these items?';
                if(!window.confirm(confirmText)) return false;
            }

            this.requestActionId = Number(req.id);
            try {
                const post = new FormData();
                post.append('defBranch', localStorage.getItem('defBranch'));
                post.append('financeYear', localStorage.getItem('financeYear'));
                post.append('type', 'confirmTechnicianPartRequest');
                post.append('auth', this.$cookies.get(this.$store.state.COOKIEPhase));
                post.append('data[request_id]', req.id);
                post.append('data[status]', status);
                post.append('data[note]', status === 'fulfilled' ? 'Requester confirmed items received' : 'Requester declined receiving items');

                const response = await axios.post(this.$store.state.SAMCOTEC.r_path, post);
                if(response && response.data && response.data.error && response.data.error.number === 200){
                    await this.getCard(this.card.id, 'spare_parts');
                }
            } finally {
                this.requestActionId = 0;
            }
        },
        openManageWorkersDialog() {
            this.loadTechnicianWorkload();
            this.workerAssignments = [];

            const existing = Array.isArray(this.card.worker_assignments) ? this.card.worker_assignments : [];
            if(existing.length) {
                this.workerAssignments = existing.map((item, idx) => ({
                    key: `existing-${Date.now()}-${idx}`,
                    workerId: item.worker_id ? String(item.worker_id) : '',
                    rowId: item.row_id ? String(item.row_id) : '',
                    notes: item.notes || '',
                    expected_hours: item.expected_hours !== undefined && item.expected_hours !== null ? String(item.expected_hours) : '',
                    percentage: item.percentage !== undefined && item.percentage !== null ? String(item.percentage) : ''
                }));
            } else if(this.card && Array.isArray(this.card.rows)) {
                this.card.rows.forEach((row, idx) => {
                    const empIds = String(row.empid || '').split(',').map(v => v.trim()).filter(Boolean);
                    empIds.forEach((empId, inx) => {
                        this.workerAssignments.push({
                            key: `row-${idx}-${inx}-${Date.now()}`,
                            workerId: String(empId),
                            rowId: String(row.id || ''),
                            notes: '',
                            expected_hours: row.expected_hours !== undefined && row.expected_hours !== null ? String(row.expected_hours) : '',
                            percentage: ''
                        });
                    });
                });
            }

            if(!this.workerAssignments.length) {
                this.addAssignmentRow();
            }

            this.manageWorkersDialog = true;
        },
        addAssignmentRow() {
            this.workerAssignments.push({
                key: `new-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
                workerId: '',
                rowId: '',
                notes: '',
                expected_hours: '',
                percentage: ''
            });
        },
        removeAssignmentRow(index) {
            this.workerAssignments.splice(index, 1);
            if(!this.workerAssignments.length) {
                this.addAssignmentRow();
            }
        },
        onAssignmentChanged(index) {
            const current = this.workerAssignments[index];
            if(!current || !current.workerId || !current.rowId) return;
            if((current.expected_hours === '' || Number(current.expected_hours || 0) <= 0) && this.card && Array.isArray(this.card.rows)) {
                const selectedRow = this.card.rows.find((row) => String(row.id || '') === String(current.rowId));
                if(selectedRow && Number(selectedRow.expected_hours || 0) > 0) {
                    current.expected_hours = String(selectedRow.expected_hours);
                }
            }

            const duplicated = this.workerAssignments.some((item, idx) => {
                if(idx === index) return false;
                return String(item.workerId) === String(current.workerId) && String(item.rowId) === String(current.rowId);
            });

            if(duplicated) {
                current.workerId = '';
                this.$snotify.error(this.lang.worker_assignment_duplicate || 'هذا العامل مضاف مسبقًا لنفس البند', this.lang.alert, {
                    timeout: 4000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.lang.close,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
            }
        },
        async saveManageWorkersAssignments() {
            const cleaned = this.workerAssignments
                .filter(item => item.workerId && item.rowId)
                .map(item => ({
                    worker_id: String(item.workerId),
                    row_id: String(item.rowId),
                    notes: item.notes || '',
                    expected_hours: item.expected_hours === '' ? '0' : String(item.expected_hours),
                    percentage: item.percentage === '' ? '' : String(item.percentage)
                }));

            const missingEstimate = cleaned.find(item => Number(item.expected_hours || 0) <= 0);
            if(missingEstimate) {
                this.showFormError(this.estimatedHoursRequiredMessage());
                return false;
            }

            const pairSet = new Set();
            for(const item of cleaned) {
                const key = `${item.row_id}-${item.worker_id}`;
                if(pairSet.has(key)) {
                    this.$snotify.error(this.lang.worker_assignment_duplicate || 'هذا العامل مضاف مسبقًا لنفس البند', this.lang.alert, {
                        timeout: 4000,
                        showProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        position: SnotifyPosition.centerCenter,
                        buttons: [
                            {
                                text: this.lang.close,
                                action: (toast) => {
                                    this.$snotify.remove(toast.id);
                                }
                            },
                        ]
                    });
                    return false;
                }
                pairSet.add(key);
            }

            this.card.worker_assignments = cleaned;
            if(Array.isArray(this.card.rows)) {
                this.card.rows = this.card.rows.map((row) => {
                    const rowId = String(row.id || '');
                    const rowAssignments = cleaned.filter(item => item.row_id === rowId);
                    const workerIds = rowAssignments.map(item => item.worker_id).join(',');
                    const expectedHours = rowAssignments.reduce((maxHours, item) => Math.max(maxHours, Number(item.expected_hours || 0)), 0);
                    const workerNames = rowAssignments
                        .map(item => {
                            const worker = this.workers.find(w => String(w.value) === String(item.worker_id));
                            return worker ? worker.text : '';
                        })
                        .filter(Boolean)
                        .join(' - ');

                    return {
                        ...row,
                        empid: workerIds,
                        emp_name: workerNames,
                        expected_hours: expectedHours || row.expected_hours || 0,
                        worker_assignments: rowAssignments
                    };
                });
            }

            try {
                const post = new FormData();
                post.append('defBranch', localStorage.getItem('defBranch'));
                post.append('financeYear', localStorage.getItem('financeYear'));
                post.append('type', 'saveManageWorkersAssignments');
                post.append('auth', this.$cookies.get(this.$store.state.COOKIEPhase));
                post.append('data[lang]', this.$cookies.get(this.$store.state.LangCooki));
                post.append('data[cardid]', this.card.id);
                post.append('data[assignments]', JSON.stringify(cleaned));

                const response = await axios.post(this.$store.state.SAMCOTEC.r_path, post);
                if(!response || !response.data || !response.data.error || response.data.error.number !== 200) {
                    this.$snotify.error(this.lang.error_happend || 'حدث خطأ أثناء الحفظ', this.lang.alert, {
                        timeout: 4000,
                        showProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        position: SnotifyPosition.centerCenter,
                        buttons: [
                            {
                                text: this.lang.close,
                                action: (toast) => {
                                    this.$snotify.remove(toast.id);
                                }
                            },
                        ]
                    });
                    return false;
                }
                await this.getCard(this.card.id);
            } catch (e) {
                this.$snotify.error(this.lang.error_happend || 'حدث خطأ أثناء الحفظ', this.lang.alert, {
                    timeout: 4000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.lang.close,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                return false;
            }

            this.manageWorkersDialog = false;
            this.$snotify.success(this.lang.successfuly_job || 'Done successfully', this.lang.alert, {
                timeout: 2500,
                showProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                position: SnotifyPosition.centerCenter,
                buttons: [
                    {
                        text: this.lang.close,
                        action: (toast) => {
                            this.$snotify.remove(toast.id);
                        }
                    },
                ]
            });
            return true;
        },
        delThis(id) {
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','deleteCard')
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[lang]',this.$cookies.get(this.$store.state.LangCooki));
            post.append('data[id]',id);
            axios.post(
                this.$store.state.SAMCOTEC.r_path,post
            ).then((response) => {

                let message = "تم الحذف بنجاح";
                this.$snotify.error(message, this.lang.alert, {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.lang.close,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                this.$parent.getCurrentCards();

                document.getElementById('closecardview').click();
                return false;
            })
        },
        async getStaticOptions(){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','getStaticOptions')
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[lang]',this.$cookies.get(this.$store.state.LangCooki));
            post.append('data[phrase]','')
            const response = await axios.post(
                this.$store.state.SAMCOTEC.r_path,post
            );
            if(response && response.data){
                this.static_options = response.data.results.res1
            }
        },
        goUpdate(id)
        {
            this.$refs.updateCardInfo.id = id
            this.$refs.updateCardInfo.getCard();
        },
        showModal(type,index) {
            this.$refs.showModal.showtable = true;
            this.$refs.showModal.users = this.workerOptions;
            this.$refs.showModal.type = type;
            this.$refs.showModal.t_index = index;
            this.$refs.showModal.estimatedHours = 0;
            if(type == 5){
                this.$refs.showModal.techs = this.newrow.workers_name;
                this.$refs.showModal.estimatedHours = Number(this.newrow.expected_hours || 0);
            }else if(type == 3){
                this.$refs.showModal.techs = this.card.rows[index].empid;
                this.$refs.showModal.estimatedHours = Number(this.rowExpectedHours(this.card.rows[index]) || 0);
            }else if(type == 4){
                this.$refs.showModal.techs = this.newrow1.workers_name;
            }
            // console.log(this.workersList)
        },
        getDiscount() {
            if(this.per_discount == '') this.per_discount = 0;
            if(this.per_discount == 0) this.card.discount = 0;
            if(this.per_discount != 0){
                this.card.discount = parseFloat(this.card.total) * (parseFloat(this.per_discount) / 100)
            }
            this.updateDiscount();
        },
        updateDiscount(){
            if(this.card.invoiceid != 0) return false;
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','updateDiscount');
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[id]',this.card.id);
            post.append('data[discount]',this.card.discount);
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
                const res = response.data;
                this.getCard(this.card.id);
                // this.paytypeOp = t;

                // this.paytype = res.results.data[0].id;
            })
        },
        getPyamentType(){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','getPayTypes');
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[id]',"all");
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
                const res = response.data;
                this.pTypes = [];
                for(let i=0;i<res.results.data.length;i++){
                    this.pTypes.push({
                        text: this.$parent.lang.langname == 'ar' ? res.results.data[i].type_name : res.results.data[i].type_name_en,
                        value: res.results.data[i].id
                    })
                }
                // this.paytypeOp = t;

                // this.paytype = res.results.data[0].id;
            })
        },
        updateRows(index){
            const row = this.card && this.card.rows ? this.card.rows[index] : null;
            if(row && Number(row.type || 0) === 1 && Number(row.expected_hours || 0) <= 0){
                this.showFormError(this.estimatedHoursRequiredMessage());
                return false;
            }
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","updateCardRow");
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[lang]',this.$cookies.get(this.$store.state.LangCooki));
            post.append('data[row]',JSON.stringify(this.card.rows[index]));
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) =>{
                if(response && response.data && response.data.error && response.data.error.number !== 200){
                    this.showFormError(response.data.error.message || this.lang.error_happend || 'Error');
                    return false;
                }
                if(response && response.data){
                    let message = this.lang.successfuly_job;
                    this.$snotify.error(message, this.lang.alert, {
                        timeout: 1000000,
                        showProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        position: SnotifyPosition.centerCenter,
                        buttons: [
                            {
                                text: this.lang.close,
                                action: (toast) => {
                                    this.$snotify.remove(toast.id);
                                }
                            },
                        ]
                    });
                    this.getCard(this.card.id);
                    return false;

                }
            })
        },
        openWhatsAPP() {
            this.$refs.sendCardWhats.cardid = this.card.id;
            this.$refs.sendCardWhats.number_list = this.card.mobile;
        },
        async generateCustomerLink(){
            if(this.generatingCustomerLink || !this.card || !this.card.id){
                return;
            }
            this.generatingCustomerLink = true;
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","generateMaintenanceCustomerLink");
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[cardid]',this.card.id);

            try {
                const response = await axios.post(this.$store.state.SAMCOTEC.r_path, post);
                const data = response && response.data ? response.data : {};
                if(data.error && data.error.number != 200){
                    this.$snotify.error(data.error.message || this.lang.please_check_data, this.lang.warning, {
                        timeout: 5000,
                        showProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        position: SnotifyPosition.centerCenter,
                    });
                    return;
                }
                const link = (data.results && data.results.case_url) ||
                    (data.results && data.results.data && data.results.data.case_url) || '';
                this.customerCaseLink = link;
                if(link){
                    this.copyCustomerLink();
                    this.$snotify.success(this.lang.customer_link_generated || 'Customer link generated', '', {
                        timeout: 5000,
                        showProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        position: SnotifyPosition.centerCenter,
                    });
                }else{
                    this.$snotify.error(this.lang.please_check_data, this.lang.warning, {
                        timeout: 5000,
                        showProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        position: SnotifyPosition.centerCenter,
                    });
                }
            } catch (error) {
                this.$snotify.error(this.lang.please_check_data, this.lang.warning, {
                    timeout: 5000,
                    showProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                });
            } finally {
                this.generatingCustomerLink = false;
            }
        },
        copyCustomerLink(){
            if(!this.customerCaseLink){
                return;
            }
            if(navigator.clipboard && navigator.clipboard.writeText){
                navigator.clipboard.writeText(this.customerCaseLink);
                return;
            }
            const input = document.createElement('textarea');
            input.value = this.customerCaseLink;
            input.setAttribute('readonly', 'readonly');
            input.style.position = 'fixed';
            input.style.opacity = '0';
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
        },
        openCustomerLink(){
            if(this.customerCaseLink){
                window.open(this.customerCaseLink, '_blank');
            }
        },
        openLWhatsAPP() {
            let mobile = "966"+this.card.mobile.substring(1)
            window.open("https://wa.me/"+mobile,"_blank")
        },
        async _chStatus(id){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","changeCardStatus");
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[lang]',this.$cookies.get(this.$store.state.LangCooki));
            post.append('data[id]',this.card.id);
            post.append('data[status]',id);
            const response = await axios.post(this.$store.state.SAMCOTEC.r_path, post)
            if(response && response.data){
                this.getCard(this.card.id);
                this.iterms = '';
            }
        },
        openSign(){
            // $router.push({path: '/signcard/'+card.id})
            if(this.$store.state.licenseType.showFullsign){
                window.open('/signcard/'+this.card.id,'_blank');
            }else{
                window.open('/signcard/'+this.card.id,'_blank','width:500;height=480');
            }

        },
        async addTerms(){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","addCardTerms");
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[lang]',this.$cookies.get(this.$store.state.LangCooki));
            post.append('data[id]',this.card.id);
            post.append('data[terms]',this.iterms);
            const response = await axios.post(this.$store.state.SAMCOTEC.r_path, post)
            if(response && response.data){
                this.getCard(this.card.id);
                this.iterms = '';
            }
        },
        addInvoice(){
            this.getCard(this.card.id);
            this.$refs.addInvoice.getNewInvoiceID();
            this.$refs.addInvoice.invoice.invtype = 2;
            if(!Array.isArray(this.card.carsjson) || this.card.carsjson.length == 0){
                this.card.carsjson = [{
                    c1: '',
                    c2: '',
                    c3: '',
                    text: '',
                    plate_number: '',
                    color: '',
                    model: '',
                    made_year: '',
                    workdes: '',
                    vin: '',
                    engine_meter: '',
                    next_oil_change: '',
                    brand: '',
                }]
            }else{
                let cars = [];
                for(let i=0;i<this.card.carsjson.length;i++){
                    let c = this.card.carsjson[i].plate_number.split(" ")
                    cars.push({
                        c1: c[0],
                        c2: c[1],
                        c3: c[2],
                        text: c[3],
                        plate_number: this.card.carsjson[i].plate_number,
                        color: this.card.carsjson[i].color,
                        model: this.card.carsjson[i].model,
                        made_year: this.card.carsjson[i].made_year,
                        workdes: '',
                        vin: this.card.carsjson[i].vin,
                        engine_meter: this.card.carsjson[i].engine_meter == 'undefined' ? "" : this.card.carsjson[i].engine_meter,
                        next_oil_change: '',
                        brand: '',
                    })
                }
                this.card.carsjson = cars;
            }
            this.$refs.addInvoice.cars = this.card.carsjson;

            this.$refs.addInvoice.customer.mobile = this.card.mobile;
            if(this.card.customer_type == 2 || this.card.customer_type == 3){
                this.$refs.addInvoice.company = this.card.company;
            }

            this.$refs.addInvoice.invoice.notes = "";
            this.$refs.addInvoice.customer = this.card.client;
            this.$refs.addInvoice.invoice.work_type = this.work_type;
            this.$refs.addInvoice.cctype = this.card.customer_type;
            this.$refs.addInvoice.invoice.discount = this.card.discount;
            this.$refs.addInvoice.invoice.customer_name = this.card.customer_name;
            this.$refs.addInvoice.invoice.customer_afforded = this.card.customer_afforded;
            this.$refs.addInvoice.company.po_number = this.card.po_number;
            this.$refs.addInvoice.company.po_date = this.card.po_date;

            this.$refs.addInvoice.tbrows = this.card.rows;
            this.$refs.addInvoice.cardid = this.card.id;

            this.$refs.addInvoice.customer.mobile = this.card.mobile;
            this.$refs.addInvoice.getName(0)
            this.$refs.addInvoice.changeCusType(parseFloat(this.card.customer_type) - 1 );
            this.$refs.addInvoice.calcAll();
            // console.log(this.$refs.addInvoice.company);
        },
        finishRowx(item,id){
            let message = this.lang.are_you_sure;
            if(id == 1){
                message = this.lang.are_you_sure;
            }
                this.$snotify.error(message, this.lang.alert, {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.lang.agree,
                            action: (toast) => {
                                this.finishRow(item,id);
                                this.$snotify.remove(toast.id);
                            }
                        },
                        {
                            text: this.lang.cancel,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                return false;
        },
        deleteRowx(item){
            let message = this.lang.are_you_sure;
                this.$snotify.error(message, this.lang.alert, {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.lang.agree,
                            action: (toast) => {
                                this.deleteRow(item);
                                this.$snotify.remove(toast.id);
                            }
                        },
                        {
                            text: this.lang.cancel,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                return false;
        },
        async deleteRow(item){

            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","deleteItemFromCard");
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[lang]',this.$cookies.get(this.$store.state.LangCooki));
            post.append('data[id]',item.id);
            const response = await axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            )
            if(response && response.data && response.data.results && response.data.results.data){
                 this.getProducts();
                 this.getCard(this.card.id);
                let message = this.lang.successfuly_job;
                this.$snotify.error(message, this.lang.alert, {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.lang.close,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                return false;
            }
        },
        async finishRow(item,id){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","finishItemFromCard");
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[lang]',this.$cookies.get(this.$store.state.LangCooki));
            post.append('data[id]',item.id);
            post.append('data[doit]',id);
            const response = await axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            )
            if(response && response.data && response.data.results && response.data.results.data){
                this.getProducts();
                this.getCard(this.card.id);
                let message = this.lang.successfuly_job;
                if(id == 1){
                    message = this.lang.successfuly_job;
                }
                this.$snotify.error(message, this.lang.alert, {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.lang.close,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                return false;
            }
        },
        showAttached(){
            this.$refs.viewCardGall.card.cardid = this.card.id;
            this.$refs.viewCardGall.getImages();
        },
        invpayment(){
            this.$refs.cardPayments.id = this.card.id;
            this.$refs.cardPayments.cardid = this.card.card_id;
            this.$refs.cardPayments.cAmount = parseFloat(this.total_payment);
            this.$refs.cardPayments.received_total = parseFloat(this.total_payment);
            this.$refs.cardPayments.received_total = parseFloat(this.total_payment);
        },
        async addNewRow(){
            if(Number(this.newrow.type || 0) === 1 && Number(this.newrow.expected_hours || 0) <= 0){
                this.showFormError(this.estimatedHoursRequiredMessage());
                return false;
            }
            document.getElementById('addNewRow').style.display = "none";
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","addNewRowToCardDesc");
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[lang]',this.$cookies.get(this.$store.state.LangCooki));
            Object.keys(this.newrow).forEach(key => {
                if(key == "item_name"){
                    console.log(this.newrow.item_name)
                    if(typeof this.newrow.item_name === 'object'){
                        post.append('data[item_name_op]', JSON.stringify(this.newrow.item_name));
                        Object.keys(this.newrow.item_name).forEach(key1 => {
                            post.append("data[item_name]["+key1+"]",this.newrow.item_name[key1]);
                        });
                    }else{
                        post.append("data[item_name][text]",this.newrow.item_name);
                    }
                }
                else if(key == "workers_name"){
                    if(typeof this.newrow.workers_name === 'object'){
                        let workers_name = '';
                        Object.keys(this.newrow.workers_name).forEach(key1 => {
                            workers_name += (workers_name == '' ? "" : ",") + this.newrow.workers_name[key1]
                        });
                        post.append("data[workers_name]",workers_name);
                    }else{
                        post.append("data[item_name][text]",this.newrow.item_name);
                    }
                }else{
                    post.append("data["+key+"]",this.newrow[key]);

                }
            })
            post.append("data[cardid]",this.card.id)

            const response = await axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            )
            document.getElementById('addNewRow').style.display = "inherit";
            if(response && response.data && response.data.results && response.data.results.data){

                this.getProducts();
                this.resetNewrow()
                this.getCard(this.card.id);
            }

        },
        async addNewRow1(){
            document.getElementById('addNewRow1').style.display = "none";
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","addNewRowToCard");
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[lang]',this.$cookies.get(this.$store.state.LangCooki));

            Object.keys(this.newrow1).forEach(key => {
                if(key == "item_name"){
                    if(typeof this.newrow1.item_name === 'object'){
                        Object.keys(this.newrow1.item_name).forEach(key1 => {
                            post.append("data[item_name]["+key1+"]",this.newrow1.item_name[key1]);
                        });
                    }else{
                        post.append("data[item_name][text]",this.newrow1.item_name);
                    }
                }else if(key == "workers_name"){
                    if(typeof this.newrow1.workers_name === 'object'){
                        let workers_name = '';
                        Object.keys(this.newrow1.workers_name).forEach(key1 => {
                            workers_name += (workers_name == '' ? "" : ",") + this.newrow1.workers_name[key1]
                        });
                        post.append("data[workers_name]",workers_name);
                    }
                }else{
                    if(key == 'type' && (this.newrow1[key] == '' || this.newrow1[key] == 0 || this.newrow1[key] == 1)){
                        this.newrow1[key] = 2;
                    }
                    post.append("data["+key+"]",this.newrow1[key]);
                }
            })
            post.append("data[cardid]",this.card.id)
            if(this.newrow1.paytype == 0 && this.newrow1.type == 6){
                const message = "يجب اختيار طريقة الدفع";
                this.$snotify.error(message, this.lang.alert, {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.lang.close,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                document.getElementById('addNewRow1').style.display = "";
                return false
            }else if(this.newrow1.type != 6) {
                this.newrow1.paytype = 0
            }
            post.append('data[paytype]',this.newrow1.paytype)
            const response = await axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            )
            document.getElementById('addNewRow1').style.display = "inherit";
            if(response && response.data && response.data.results && response.data.results.data){

                this.getProducts();
                this.resetNewrow()
                this.getCard(this.card.id);
            }

        },
        calcKit(){
            if(this.newrow.qty != '' && this.newrow.item_price != ''){
                const q = parseFloat(this.newrow.qty) * parseFloat(this.newrow.item_price);
                this.newrow.total = this.$RoundNums(q);
            }else{
                this.newrow.total = 0;
            }
        },
        calcKit1(){
            if(this.newrow1.qty != '' && this.newrow1.item_price != ''){
                const q = parseFloat(this.newrow1.qty) * parseFloat(this.newrow1.item_price);
                this.newrow1.total = this.$RoundNums(q);
            }else{
                this.newrow1.total = 0;
            }
        },
        getItemCode(){
            for(let i=0;i<this.products.length;i++){
                if(this.products[i].value == this.newrow.item_name.value){
                    this.newrow.itemcode = this.products[i].itemcode
                    this.newrow.itemid = this.products[i].id
                    this.newrow.item_price = this.products[i].item_price
                    this.calcKit();
                    return false;
                }
            }
        },
        getItemCode1(){
            // console.log(this.products);
            for(let i=0;i<this.products.length;i++){
                if(this.products[i].value == this.newrow1.item_name.value){
                    this.newrow1.itemcode = this.products[i].itemcode
                    this.newrow1.itemid = this.products[i].id
                    this.newrow1.item_price = this.products[i].item_price
                    this.calcKit1();
                    return false;
                }
            }
        },
        getProd(id, type){
            if(id == 1){
                const post = new FormData();
                post.append('defBranch',localStorage.getItem('defBranch'));
                post.append('financeYear',localStorage.getItem('financeYear'));
                post.append("type","getProductByid");
                post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
                post.append('data[lang]',this.$cookies.get(this.$store.state.LangCooki));
                if(type == 1){
                    post.append('data[inv_id]',this.newrow1.itemcode);
                }else{
                    post.append('data[inv_id]',this.newrow.itemcode);
                }

                axios.post(
                    this.$store.state.SAMCOTEC.r_path, post
                ).then((response) => {
                    if(response && response.data && response.data.results && response.data.results.data){
                        if(type == 1){
                            this.newrow1.itemcode = response.data.results.data.itemcode
                            this.newrow1.itemid = response.data.results.data.itemid
                            this.newrow1.type = response.data.results.data.type
                            this.newrow1.stype = response.data.results.data.stype
                            this.newrow1.item_name = response.data.results.data.item_name
                            this.newrow1.item_price = response.data.results.data.item_price
                        }else{
                            this.newrow.itemcode = response.data.results.data.itemcode
                            this.newrow.itemid = response.data.results.data.itemid
                            this.newrow.type = response.data.results.data.type
                            this.newrow.stype = response.data.results.data.stype
                            this.newrow.item_name = response.data.results.data.item_name
                            this.newrow.item_price = response.data.results.data.item_price
                        }

                    }
                })
            }else if(id == 2){
                if(this.newrow1.inv_id == '' || this.newrow1.inv_id == 0){
                    this.newrow1.item_name = "";
                    return false;
                }

                const post = new FormData();
                post.append('defBranch',localStorage.getItem('defBranch'));
                post.append('financeYear',localStorage.getItem('financeYear'));
                post.append("type","getPorchaseProducts");
                post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
                post.append('data[lang]',this.$cookies.get(this.$store.state.LangCooki));
                post.append('data[inv_id]',this.newrow1.inv_id);

                axios.post(
                    this.$store.state.SAMCOTEC.r_path, post
                ).then((response) => {
                    if(response && response.data && response.data.results && response.data.results.data){
                        this.products = response.data.results.data
                    }
                })
            }
        },
        async getProducts(){
            // if(this.newrow1.itemcode == ''){
            //     return false;
            // }
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","getProducts");
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[lang]',this.$cookies.get(this.$store.state.LangCooki));
            post.append('data[item_number]',this.newrow1.itemcode);
            const response = await axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            )

            if(response && response.data && response.data.results && response.data.results.data){
                const res = response.data.results.data;
                const res1 = response.data.results.works;
                this.allProducts = res;
                this.allWorks = res1;
                this.products = [];
                this.workdesk = [];

                for(let i=0;i<res.length;i++){
                    this.products.push({
                        text: res[i]['item_name'+this.lang.langname],
                        value: res[i]['item_name'+this.lang.langname],
                        id: res[i].id,
                        itemcode: res[i].item_code,
                        item_price: res[i].item_price
                    });
                }

                for(let i=0;i<res.length;i++){
                    this.workdesk.push({
                        text: res[i]['item_name'+this.lang.langname],
                        value: res[i]['item_name'+this.lang.langname],
                        id: res[i].id,
                        itemcode: res[i].item_code,
                        item_price: ''
                    });
                }

            }

        },
        getUsers(){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","getWorkers");
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[lang]',this.$cookies.get(this.$store.state.LangCooki));
            post.append('data[item_number]',this.newrow.itemcode);
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {

                this.workers = response.data.results.data
                if(Array.isArray(response.data.results.data) && response.data.results.data.length > 0){
                    this.newrow.workers_name = [response.data.results.data[0].value]
                    this.newrow1.workers_name = [response.data.results.data[0].value]
                }else{
                    this.newrow.workers_name = []
                    this.newrow1.workers_name = []
                }
                this.loadTechnicianWorkload();
            });
        },
        resetNewrow(){
            this.newrow = {
                vattype: 3,
                empname: '',
                itemcode: '',
                item_name: '',
                qty: 1,
                item_price: '',
                total: '',
                vat: '',
                ftotal: '',
                plate_number: this.newrow.plate_number,
                workers_name: [],
                expected_hours: '',
                type: 1,
                type_of_item: 1,
                itemid: 0,
            }
            this.newrow1 = {
                vattype: 3,
                empname: '',
                itemcode: '',
                item_name: '',
                qty: 1,
                item_price: '',
                total: '',
                vat: '',
                ftotal: '',
                plate_number: this.newrow.plate_number,
                workers_name: [],
                type: 1,
                itemid: 0,
                inv_id: '',
                paytype: 0,
            }

        },
        async getCard(id, activeTab = 'finance') {
            this.activePopCardTab = activeTab;
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","getCurretnCard");
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('lang',this.$cookies.get(this.$store.state.LangCooki))
            post.append("data[id]",id)
            const response = await axios.post(this.$store.state.SAMCOTEC.r_path,post);
            this.card = response.data.results.data;
            this.cardType = response.data.results.data.rowType;
            this.work_type = response.data.results.data.work_type
            this.terms = response.data.results.terms;
            this.currentCars = [];
            const cardCars = Array.isArray(this.card._cars) ? this.card._cars : [];
            for(let i=0;i<cardCars.length;i++){
                this.currentCars.push({
                    text:cardCars[i].plate_number,value:cardCars[i].plate_number
                })
                if(i==0){
                    this.newrow.plate_number = cardCars[i].plate_number
                    this.newrow1.plate_number = cardCars[i].plate_number
                }
            }
            if(cardCars.length === 0){
                this.newrow.plate_number = '';
                this.newrow1.plate_number = '';
            }
            await this.loadTechnicianWorkload();
            await this.loadPartRequests();
        },
        async getStatic(){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","getStaticOptions");
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('lang',this.$cookies.get(this.$store.state.LangCooki))
            post.append("data[phrase]","")
            const repsponse = await axios.post(this.$store.state.SAMCOTEC.r_path,post)
            this.vattypes = [];
            this.rowType = [];
            this.rowType1 = [];
            for(let i=0;i<repsponse.data.results.data.length;i++){
                if(repsponse.data.results.data[i].option_phrase == "vattypes"){
                    this.vattypes.push({
                        value: repsponse.data.results.data[i].value,
                        text: (this.lang.langname == "ar") ? repsponse.data.results.data[i].name_ar : repsponse.data.results.data[i].name_en
                    })
                }
                if(repsponse.data.results.data[i].option_phrase == "rowType"){
                    if(repsponse.data.results.data[i].value == 1){
                        this.rowType.push({
                            value: repsponse.data.results.data[i].value,
                            text: (this.lang.langname == "ar") ? repsponse.data.results.data[i].name_ar : repsponse.data.results.data[i].name_en
                        })
                    }else{
                        this.rowType1.push({
                            value: repsponse.data.results.data[i].value,
                            text: (this.lang.langname == "ar") ? repsponse.data.results.data[i].name_ar : repsponse.data.results.data[i].name_en
                        })
                    }

                }
            }
            this.getStaticOptions();

        },
        printWar(id){
            window.open('../api/print.php?war='+id, '_blank')
        },
        printPDFx (id,t)
        {
            let pdfFrame = document.body.appendChild(document.createElement('iframe'));
            pdfFrame.style.display = 'none';
            pdfFrame.onload = () => (void pdfFrame.contentWindow.print());
            if(t == 1)
                pdfFrame.src = '../api/print.php?invid='+id;
            if(t == 2)
                pdfFrame.src = '../api/print.php?recpid='+id;
            if(t == 3)
                pdfFrame.src = '../api/print.php?newcard='+id;
        },
        printPDF (id,t)
        {
            // let pdfFrame = document.body.appendChild(document.createElement('iframe'));
            // pdfFrame.style.display = 'none';
            // pdfFrame.onload = () => (void pdfFrame.contentWindow.print());
            let src = '';
            if(t == 1)
                src = '../api/print.php?invid='+id;
            if(t == 2)
                src = '../api/print.php?recpid='+id;
            if(t == 3)
                src = '../api/print.php?newcard='+id;

            window.open(src,"_blank")
        },
    },
}
</script>
<style>
.font-size-14{
  font-size:14px;
}
.mybtn{
  width:100%;
  font-size:.8rem;
  border:0px solid #fff;
}
.mybtn2{
  width:100%;
  font-size:.8rem;
  border:0px solid #fff;
}
.mybtn4{
  width:100%;
  font-size:.8rem;
  background:rgb(15, 90, 230) !important;
  border:0px solid #fff;
}
.mybtn3{
  width:100%;
  font-size:.8rem;
  background:#198754 !important;
  border:0px solid #fff;
}
.mybtn1{
  width:100%;
  font-size:.8rem;
  background:#fe7b33 !important;
  border:0px solid #fff;
}
.v-application .elevation-1{
 box-shadow: none !important;
}
.pop-tab-wrap{
    display:flex;
    flex-wrap:wrap;
    justify-content:center;
    gap:8px;
    margin:12px 0;
}
.pop-tab-btn{
    width:100%;
    max-width:240px;
}
@media (max-width: 576px){
    .pop-tab-btn{
        max-width:100%;
    }
}
</style>
